export default {
  text: {
    // auth
    "auth-otp-form-email-placeholder": "email@example.cz",
    "auth-otp-form-button-continue-label": "pokračovat",
    "auth-otp-form-email-sent-to": "Odeslali jsme ti kód na",
    "auth-otp-form-email-wrong-email": "špatný e-mail?",
    "auth-otp-form-button-verify-label": "přihlásit se",

    "version-check-new-version-available": "nová verze je dostupná",
    "version-check-reload": "aktualizovat",

    main_title: "Administrace",

    "menu-cms": "cms",
    "menu-pages": "Stránky",
    "menu-posts": "Příspěvky",
    "menu-commerce": "Obchod",
    "menu-analytics": "Analytics",
    "menu-settings": "Nastavení",
    "menu-help": "Nápověda",
    "menu-logout": "Odhlásit",
    "menu-publisher": "Vydavatel",
    "menu-designer": "Designer",

    "sites-main-headline": "Moje stránky",

    "option-yes": "Ano",
    "option-no": "Ne",

    monthNames: [
      "Leden",
      "Únor",
      "Březen",
      "Duben",
      "Květen",
      "Červen",
      "Červenec",
      "Srpen",
      "Září",
      "Říjen",
      "Listopad",
      "Prosinec",
    ],
    dayNames: ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"],
    dayNamesShort: ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],

    "login-header": "Přihlášení",
    "login-header-label": "Přihlásit se zde...",
    "login-user-name": "Přihlašovací jméno",
    "login-user-password": "Heslo",
    "login-user-email": "Přihlašovací email",
    "login-submit-button": "Přihlásit se",
    "login-help": "Pomoc",
    "login-use-pwd": "použít heslo",
    "login-use-pwdless": "použít odkaz do e-mailu",
    "login-use-passkey": "použít Klíč",
    "login-msg-welcome": "platforma.one",
    "login-error-wrong-password": "Špatné heslo",
    "login-error-too-many-requests": "Příliš mnoho pokusů, zkuste později.",
    "login-validator-passwordlessemail-errormessage-notvalid": "Skoro. Není tam nějaký přelkep?",
    "login-validator-passwordlessemail-errormessage-notfound": "Nenašli jsme tě. Existuješ?",
    "login-validator-passwordlessemail-errormessage-empty": "Sem by to chtělo napsat e-mail",
    "login-validator-passwordemail-errormessage-bad": "Tohle",
    "login-validator-passwordemail-errormessage-empty": "Notak, buď trochu přesnější.",
    "login-validator-passwordemail-errormessage-notvalid": "Takhle nevypadá e-mail!",
    "login-validator-password-errormessage-bad": "nebo toto není správně.",
    "login-validator-password-errormessage-empty": "No tak, hesla jsou důležitá!",
    "login-email-instructions-headline": "Mrkni do e-mailu",
    "login-email-sent-instructions-pt1": "Na e-mail",
    "login-email-sent-instructions-pt2": "letí přihlašovací tlačítko.",
    "login-email-sent-instructions-pt3": "Tohle okno můžeš zavřít.",
    "login-email-instructions-tryagain": "Zkusit znovu",

    "guest-signup-email-instructions-headline": "Hurá! Už jen jeden krok k tvému webu",
    "guest-signup-email-sent-instructions-pt1":
      "Potvrzovací odkaz ke zveřejnění tvé stránky jsme poslali na",
    "guest-signup-email-sent-instructions-pt2":
      "Toto okno můžeš zavřít. V mailu klikni na odkaz, který otevře nové.",
    "guest-signup-published-headline": "A je to!",
    "guest-signup-published-text": "Tvá stránka běží na",
    "guest-signup-published-open-btn": "Podívej se na ni",

    "main-site-menu": "Hlavní nabídka",

    "settings-header": "Nastavení",
    "site-config-title": "Název webu",

    "pages-header": "Stránky",
    "pages-add-subpage": "Přidat podstránku",
    "pages-stop-adding-subpage": "Ukončit přidávání podstránky",
    "page-qr-code-generator-page-lang": "Jazyk",
    "page-list": "Seznam stránek",
    "main-view-site": "Ukázat náhled",
    "page-selected-layout": "Rozložení",
    "page-selected-content": "Obsah",
    "page-selected-settings": "Nastavení",
    "page-selected-styles": "Vzhled",
    "page-setup-title": "Název",
    "page-setup-role": "Pořebná role",
    "page-setup-description": "Popis",
    "page-setup-slugs": "URL",
    "page-setup-visible": "Viditelné",
    "page-button-delete": "Smazat stránku",
    "page-add-hint": "Vyberte bod vložení",
    "page-duplicate": "Duplikovat",
    "page-duplicate-parent": "Nadřazená stránka",
    "page-duplicate-new-title": "Název nové stránky",
    "page-duplicate-execute": "Staniž se",
    "page-clone-fill_name": "Doplňte název stránky pro jazyk: ",
    "page-clone-parent_no_slug": "Nadřazená stránkanemá vyplněný slug",
    "page-clone-slag_for_lang": "Nadřazená stránkanemá vyplněný slug pro jazyk: ",
    "page-clone-done": "Duplikace se zdařila.",
    "page-clone-error": "Duplikace selhala!",
    "page-block-styling": "Stylování",
    "label-add-language-version": "Přidat verzi pro jazyk",

    // editor
    "editor-blockForm-main-textWithHeader-form-header-label": "nadpis",
    "editor-blockForm-main-textWithHeader-form-paragraph-label": "odstavec",
    "editor-blockForm-main-header-form-header-label": "nadpis",
    "editor-blockForm-commerce-productListing-form-productDetailPage-label": "stránka s produktem",
    "editor-blockForm-commerce-productListing-form-productDetailPage-caption":
      "produktová stránka, která se zobrazí po kliknutí na produkt v seznamu",
    "editor-blockForm-commerce-productListing-form-filterByTags-label": "filtr produktů",
    "editor-blockForm-commerce-productListing-form-filterByTags-caption":
      "štítky produktů, které se mají v této sekci zobrazit",
    "editor-blockForm-commerce-productListing-form-sortBy-label": "řazení",
    "editor-blockForm-commerce-productListing-form-sortBy-option-title-label": "název",
    "editor-blockForm-commerce-productListing-form-sortBy-option-price-label": "cena",
    "editor-blockForm-commerce-productListing-form-sortBy-option-dateUpdated-label":
      "datum aktualizace",
    "editor-blockForm-commerce-productListing-form-sortBy-option-dateCreated-label":
      "datum vytvoření",
    "editor-blockForm-commerce-productListing-form-sortBy-option-availability-label": "dostupnost",
    "editor-blockForm-commerce-productListing-form-sortBy-addField": "další pole",
    "editor-blockForm-commerce-productListing-form-limit-label": "limitovat počet",
    "editor-blockForm-commerce-productListing-form-showAllButton-label":
      "zobrazit tlačítko 'další'",
    "editor-blockForm-commerce-productListing-form-showItemsAvailable-label": "zobrazit dostupné",
    "editor-blockForm-commerce-productListing-form-showItemsUnavailable-label":
      "zobrazit nedostupné",
    "editor-blockForm-commerce-productListing-form-showItemsForPreorder-label":
      "zobrazit předprodej",
    "editor-blockForm-commerce-productListing-form-showFilters-label": "zobrazit filtry",

    "dashboard-coming-soon": "zde bude brzy přehled",

    "generic-download": "Stáhnout",
    "commerce-generate-qr-code": "Generovat QR kód",
    "commerce-remove-variant": "Odstranit variantu",
    "commerce-qr-code-generator-auto-add-to-cart": "Automaticky přidat do košíku",
    "commerce-qr-code-generator-delivery-method": "Doručovací metoda",
    "commerce-qr-code-generator-hide-other-delivery-methods": "Schovat ostatní doručovací metody",
    "commerce-order-name-anonymous": "bez jména",
    "commerce-order-item-giftcard-resendToCustomer": "poslat zákazníkovi",
    "commerce-order-item-giftcard-resendToRecipient": "poslat obdarovanému",
    "commerce-order-item-giftcard-download": "stáhnout",
    "commerce-header": "E-shop",
    "commerce-shop-name": "Název obchodu",
    "commerce-no-site": "Nejprve vyberte web",
    "commerce-new-eshop": "Založit nový e-shop",
    "commerce-carts": "Košíky",
    "commerce-orders": "Objednávky",
    "commerce-inventory": "Produkty",
    "commerce-shop-items": "Položky e-shopu",
    "commerce-customers": "Zákazníci",
    "commerce-subscriptions": "Subscriptions",
    "commerce-orders-setup": "Nastavení",
    "commerce-export": "Export",
    "commerce-orders-flow-setup": "Nastavení stavů objednávek",
    "commerce-shop-create-model": "Vytvořit novou specifikaci formuláře produktu",
    "commerce-shop-update-model": "Upravit specifikaci formuláře produktu",
    "commerce-products-header": "Produkty",
    "commerce-product-attr-name": "Název pole",
    "commerce-product-model-name": "Název typu produktu",
    "commerce-shop-create-product": "Vytvoření nového produktu",
    "commerce-shop-update-product": "Změna detailů produktu",
    "commerce-product-header": "Produkt",
    "commerce-fee-reports": "Poplatky",
    "commerce-fee-billing": "Vyúčtování",
    "product-created-info": "Produkt by vytvořen.",
    "product-not-created-error": "Problém zabránil vytvoření produktu!",
    "product-saved-info": "Produkt byl upraven.",
    "product-not-saved-error": "Problém zabránil upravení produktu!",
    "product-question-delete": "Opravdu chcete odebrat produkt (včetně variant)?",
    "product-image-main": "Hlavní produktu",
    "product-image-variant": "Hlavní varianty",
    "product-fees": "Poplatky",
    "product-sku-already-exists": "SKU musí být unikátní",
    "upload-file-in-process": "Probíhá nahrávání",
    "commerce-setup": "Nastavení vlastností",
    "commerce-supported-curr": "Podporované měny",
    "commerce-default-curr": "Výchozí měna",
    "commerce-supported-langs": "Podporované jazyky",
    "commerce-default-lang": "Výchozí jazyk",
    "commerce-order-num-format": "Formát čísla objednávky",
    "commerce-order-num-format-hint": "...",
    "commerce-sell-units": "Prodejní jednotky",
    "commerce-sell-units-hint": "...",
    "commerce-bank-connection": "Bankovní spojení",
    "commerce-bank-name": "Název banky",
    "commerce-bank-code": "Číslo banky",
    "commerce-account-number": "Číslo účtu",
    "commerce-iban": "IBAN",
    "commerce-swift": "SWIFT",
    "commerce-company-address": "Adresa společnosti",
    "commerce-setup-payments": "Nasvatení plateb",
    "commerce-payment-methods": "Platební metody",
    "commerce-payment-method-add": "Přidat další metodu platby",
    "commerce-tax-values": "Povolené sazby daně",
    "commerce-delivery-planning": "Doručovací sloty",
    "commerce-delivery-planning-bulk-edit-enable": "Hromadné úpravy",
    "commerce-delivery-planning-bulk-edit-disable": "Ukončit hromadné úpravy",
    "commerce-delivery-planning-delete-all": "Smazat vše",
    "commerce-delivery-channels": "Podporované doručovací metody",
    "commerce-setup-deliveries": "Nastavení doručování",
    "commerce-delivery-method-add": "Přidat další metodu doručení",
    "commerce-setup-delivery-planning-settings": "Nastavení doručovacího plánu",
    "commerce-setup-delivery-planning": "Doručovací plán",
    "commerce-delivery-next-day-order": "Last next-day order at:",
    "commerce-delivery-next-days": "Zobrazit nasledující dny:",
    "commerce-delivery-use-defaults": "Použít šablonu",
    "commerce-delivery-add-slot": "+ Přidat slot",
    "commerce-delivery-additional-fields": "Dodatečná pole na formuláři košíku",
    "commerce-delivery-add-field": "+ Přidat pole",
    "commerce-delivery-setup": "Plán doručování",
    "commerce-delivery-default-slots": "Šablona slotů",
    "commerce-setup-delivery-planning-slots": "Aktivní sloty",
    "commerce-delivery-settings": "Nastavení",
    "commerce-delivery-point-title": "Doručovací místo",
    "commerce-flow-cmd-set": "Nastavit hodnotu",
    "commerce-flow-cmd-exe": "Provést operaci",
    "commerce-flow-operation-request-liftago": "Objednat Liftago",
    "commerce-flow-operation-zasilkovna-upload-to-zasilkovna": "Nahrát do Zásilkovny",
    "commerce-flow-operation-get-shipping-labels": "Vytisknout štítky",
    "commerce-flow-operation-send-order-state-change-notification": "E-mail o změně stavu obj.",
    "commerce-flow-check-equal": "Rovno",
    "commerce-flow-check-not-equal": "Nerovno",
    "commerce-flow-check-contains": "Obsahuje",
    "commerce-flow-check-not-contains": "Neobsahuje",

    "commerce-order-tags-paid": "zaplacená",
    "commerce-order-tags-unpaid": "nezaplacená",
    "commerce-order-tags-contactless": "bezkontaktní",

    "commerce-order-menu-markAsPaidManually": "Označit jako zaplacenou manuálně",
    "commerce-order-menu-downloadInvoice": "Stáhnout fakturu",
    "commerce-order-menu-sendInvoice": "Poslat fakturu zákazníkovi",
    "commerce-order-menu-createRefundSlip": "Vytvořit opravný doklad",
    "commerce-order-menu-downloadRefundSlip": "Stáhnout opravný doklad",
    "commerce-order-menu-addPrivateNote": "Přidat poznámku",
    "commerce-order-menu-changeState": "Změnit stav",
    "commerce-order-menu-sendEmail": "Poslat e-mail zákazníkovi",
    "commerce-order-menu-openInFirestore": "Otevřít ve Firestore",
    "commerce-order-menu-openInFirestoreCart": "Otevřít ve Firestore (košík)",

    "commerce-orders-items-filter-order-state": "stav",
    "commerce-orders-items-filter-delivery-method": "doprava",
    "commerce-orders-items-filter-delivery-branch": "pobočka",

    "commerce-orders-filter-title": "Filtry",
    "commerce-orders-filter-payment-status": "Stav platby",
    "commerce-orders-filter-payment-paid": "Zaplaceno",
    "commerce-orders-filter-payment-unpaid": "Nezaplaceno",
    "commerce-orders-filter-order-state": "Stav objednávky",
    "commerce-orders-filter-order-state-placeholder": "Vyberte stavy",
    "commerce-orders-filter-delivery-method": "Způsob dopravy",
    "commerce-orders-filter-delivery-method-placeholder": "Vyberte způsoby dopravy",
    "commerce-orders-filter-delivery-branch": "Pobočka",
    "commerce-orders-filter-delivery-branch-placeholder": "Vyberte pobočky",
    "commerce-orders-filter-slot-dates": "Datum slotu",
    "commerce-orders-filter-slot-date-from": "Od",
    "commerce-orders-filter-slot-date-to": "Do",
    "commerce-orders-filter-products": "Produkty",
    "commerce-orders-filter-products-placeholder": "Vyberte produkty",
    "commerce-orders-filter-saved-filters": "Uložené filtry",
    "commerce-orders-filter-reset": "Resetovat",
    "commerce-orders-filter-save": "Uložit",
    "commerce-orders-filter-close": "Zavřít",
    "commerce-orders-filter-save-title": "Uložit filtr",
    "commerce-orders-filter-save-name-label": "Název filtru",
    "commerce-orders-filter-save-name-placeholder": "např. Vánočka 23. 12.",
    "commerce-orders-filter-save-button": "Uložit",
    "commerce-orders-filter-save-cancel": "Zrušit",
    "commerce-orders-filter-saved": "Uložené",
    "commerce-orders-filter-payment": "Platba",
    "commerce-orders-filter-fulfillment": "Stav",
    "commerce-orders-filter-delivery": "Doprava",
    "commerce-orders-filter-slots": "Slot",
    "commerce-orders-filter-product": "Produkt",
    "commerce-orders-filter-button": "Filtr",
    "commerce-orders-filter-button-with-count": "Filtr [%0]",
    "commerce-orders-filter-button-with-name": "Filtr [%0]",

    "commerce-orders-summary-button": "Souhrn",
    "commerce-orders-summary-title": "Souhrn",
    "commerce-orders-summary-orders": "Objednávky",
    "commerce-orders-summary-price": "Celková cena",
    "commerce-orders-summary-products": "Produkty",
    "commerce-orders-summary-no-products": "Žádné produkty ve filtrovaných objednávkách",

    "commerce-orders-items-table-col-title": "název",
    "commerce-orders-items-table-col-item-count": "počet",
    "commerce-orders-items-table-col-order-number": "objednávka",
    "commerce-orders-items-table-col-order-price": "cena obj.",
    "commerce-orders-items-table-col-order-state": "stav",
    "commerce-orders-items-table-col-delivery-method": "doprava",
    "commerce-orders-items-table-col-delivery-branch": "pobočka",
    "commerce-orders-items-table-col-delivery-slot": "slot",
    "commerce-orders-items-table-col-customer": "zákazník",
    "commerce-orders-items-table-col-payment": "platba",
    "commerce-orders-items-table-col-ordered-at": "objednáno",

    "commerce-orders-send-email": "odeslat e-mail",
    "commerce-orders-change-state": "změnit stav",
    "commerce-order-send-email-title-single": "odeslat e-mail zákazníkovi",
    "commerce-order-send-email-title-multiple": "odeslat e-mail %0 zákazníkům",
    "commerce-order-send-email-mode": "režim",
    "commerce-order-send-email-mode-custom": "vlastní",
    "commerce-order-send-email-mode-template": "ze šablony",
    "commerce-order-send-email-subject": "předmět e-mailu",
    "commerce-order-send-email-body": "tělo e-mailu",
    "commerce-order-send-email-template": "šablona",
    "commerce-order-send-email-available-variables": "dostupné proměnné",
    "commerce-order-send-email-preview": "náhled",
    "commerce-order-send-email-will-send-to": "e-mail bude odeslán na %0 objednávek",
    "commerce-order-send-email-send": "odeslat",
    "commerce-order-send-email-send-multiple": "odeslat na %0 objednávek",
    "commerce-order-send-email-cancel": "zrušit",
    "email-sent-to-customer": "e-mail odeslán zákazníkovi",

    "commerce-order-change-state-dialog-title-single": "změnit stav objednávky",
    "commerce-order-change-state-dialog-title-multiple": "změnit stav pro %0 objednávek",
    "commerce-order-change-state-dialog-new-state-label": "nový stav",
    "commerce-order-change-state-dialog-will-change": "stav bude změněn pro %0 objednávek",
    "commerce-order-change-state-dialog-save": "uložit",
    "commerce-order-change-state-dialog-save-confirm": "potvrdit",
    "commerce-order-change-state-dialog-cancel": "zrušit",

    "commerce-email-template-table-col-name": "název",
    "commerce-email-template-table-col-description": "popis",
    "commerce-email-template-add-button": "šablona",
    "commerce-email-template-form-title-add": "přidat šablonu",
    "commerce-email-template-form-title-edit": "upravit šablonu",
    "commerce-email-template-form-name-label": "název šablony",
    "commerce-email-template-form-description-label": "popis šablony",
    "commerce-email-template-form-email-section": "e-mail",
    "commerce-email-template-form-subject-label": "předmět e-mailu",
    "commerce-email-template-form-subject-caption": "proměnné: {{názevProměnné}}",
    "commerce-email-template-form-message-label": "zpráva e-mailu",
    "commerce-email-template-form-message-caption": "proměnné: {{názevProměnné}}",
    "commerce-email-template-form-available-variables": "dostupné proměnné",
    "commerce-email-template-form-markdown-help": "podporuje formát markdown URL: [text odkazu](https://example.com)",
    "commerce-email-template-form-save": "uložit",
    "commerce-email-template-form-send-test": "odeslat test",
    "commerce-email-template-form-cancel": "zrušit",
    "commerce-email-template-form-preview": "náhled",
    "commerce-email-template-form-test-dialog-title": "testovací odeslání",
    "commerce-email-template-form-test-dialog-email-label": "e-mail",
    "commerce-email-template-form-test-dialog-send": "odeslat",
    "commerce-email-template-variable-orderNumber": "číslo objednávky",
    "commerce-email-template-variable-orderDate": "datum objednávky",
    "commerce-email-template-variable-customerFirstName": "jméno zákazníka",
    "commerce-email-template-variable-customerLastName": "příjmení zákazníka",
    "commerce-email-template-variable-customerFullName": "celé jméno zákazníka",
    "commerce-email-template-variable-deliveryMethodName": "název doručovací metody",
    "commerce-email-template-variable-branchName": "název pobočky",
    "commerce-email-template-variable-slotDateTime": "datum a čas slotu",
    "commerce-email-template-variable-slotDate": "datum slotu",
    "commerce-email-template-variable-slotTime": "čas slotu",
    "commerce-email-template-variable-slotDaysRelative": "relativní dny slotu",

    "commerce-price-brutto": "s DPH",
    "commerce-price-netto": "bez DPH",
    "commerce-price-units": "jednotek",
    "commerce-price-enter-without-vat": "zadat ceny bez DPH",
    "commerce-price-enter-with-vat": "zadat ceny s DPH",
    "commerce-price-currency": "měna",
    "commerce-price-vat": "DPH",
    "commerce-price-initial": "výchozí",

    "commerce-promo-codes": "slevové kódy",
    "commerce-gift-cards": "dárkové karty",
    "commerce-promocode-label": "Kód",
    "commerce-promocode-codeslist": "Seznam kódů",
    "commerce-promocode-count": "Počet použití",
    "commerce-promocode-unit": "Jednotka",
    "commerce-promocode-value": "Hodnota",
    "commerce-promocode-from": "Platnost od",
    "commerce-promocode-to": "Platnost do",
    "commerce-promocode-tags": "Štítky",
    "commerce-promocode-note": "Poznámka",
    "commerce-promocode-kind": "Typ",

    // commerce gift cards
    "commerce-giftcards-table-code": "kód",
    "commerce-giftcards-table-status": "stav",
    "commerce-giftcards-table-value": "hodnota",
    "commerce-giftcards-table-valueRemaining": "zůstatek",
    "commerce-giftcards-table-customerName": "jméno",
    "commerce-giftcards-table-product": "produkt",
    "commerce-giftcards-table-validFrom": "platnost od",
    "commerce-giftcards-table-validTo": "platnost do",
    "commerce-giftcards-table-purchasedIn": "objednávka",
    "commerce-giftcards-table-orderedAt": "objednáno",
    "commerce-giftcards-table-usedAt": "použita",
    "commerce-giftcards-table-usage": "použití",
    "commerce-giftcards-table-createdAt": "vytvořena",

    "commerce-giftcards-status-available": "aktivní",
    "commerce-giftcards-status-used": "vyčerpaná",
    "commerce-giftcards-status-usedPartially": "částečně vyčerpaná",
    "commerce-giftcards-status-expired": "propadlá",
    "commerce-giftcards-status-purchased": "zakoupená",
    "commerce-giftcards-status-notPurchased": "nezakoupená",

    "commerce-giftcards-details-allowedUsage-atStore": "v obchodě",
    "commerce-giftcards-details-allowedUsage-eShop": "na e-shopu",
    "commerce-giftcards-details-allowedUsage-subtractable": "odečitatelná",
    "commerce-giftcards-details-history-col-label-amount": "částka",
    "commerce-giftcards-details-history-col-label-note": "poznámka",
    "commerce-giftcards-details-history-col-label-date": "datum",
    "commerce-giftcards-details-history-col-label-time": "čas",
    "commerce-giftcards-details-valid": "platná",
    "commerce-giftcards-details-valueLeft": "zůstatek",
    "commerce-giftcards-details-details": "detail",
    "commerce-giftcards-details-allowedUsage": "povolené použití",
    "commerce-giftcards-details-validity-from": "platnost od",
    "commerce-giftcards-details-validity-to": "platnost do",
    "commerce-giftcards-details-history": "historie",
    "commerce-giftcards-details-order": "objednávka",
    "commerce-giftcards-details-transact": "transakce",

    "commerce-giftcards-add-title": "Nová dárková karta",
    "commerce-giftcards-add-form-field-multiple-label": "počet",
    "commerce-giftcards-add-form-field-multiple-option-single": "jedna",
    "commerce-giftcards-add-form-field-multiple-option-multiple": "více",
    "commerce-giftcards-add-form-field-code-label": "kód",
    "commerce-giftcards-add-form-field-code-caption":
      "Libovolný kód, např. GC-2345456 nebo 42392004",
    "commerce-giftcards-add-form-field-codes-label": "seznam kódů",
    "commerce-giftcards-add-form-field-codes-caption": "Libovolné kódy oddělené novým řádkem.",
    "commerce-giftcards-add-form-field-value-label": "hodnota",
    "commerce-giftcards-add-form-field-value-caption": "Libovolná částka, např. 100 nebo 10000.00",
    "commerce-giftcards-add-form-field-usage-label": "povolená použití",
    "commerce-giftcards-add-form-field-allowOffline-label": "v obchodě",
    "commerce-giftcards-add-form-field-allowOnline-label": "na e-shopu",
    "commerce-giftcards-add-form-field-allowCredit-label": "odečítání (více použití)",
    "commerce-giftcards-add-form-field-validity-label": "platnost",
    "commerce-giftcards-add-form-field-from-label": "od",
    "commerce-giftcards-add-form-field-from-caption": "zobrazuje časovou zónu",
    "commerce-giftcards-add-form-field-to-label": "do",
    "commerce-giftcards-add-form-field-to-caption": "zobrazuje časovou zónu",
    "commerce-giftcards-add-form-field-validity-presets-label": "předvolba",
    "commerce-giftcards-add-form-field-validity-presets-1m-label": "1 měsíc",
    "commerce-giftcards-add-form-field-validity-presets-3m-label": "3 měsíce",
    "commerce-giftcards-add-form-field-validity-presets-6m-label": "6 měsíců",
    "commerce-giftcards-add-form-field-validity-presets-1y-label": "1 rok",
    "commerce-giftcards-add-form-field-validity-presets-2y-label": "2 roky",
    "commerce-giftcards-add-form-field-validity-presets-3y-label": "3 roky",
    "commerce-giftcards-add-form-field-validity-presets-5y-label": "5 let",
    "commerce-giftcards-add-form-field-validity-presets-10y-label": "10 let",
    "commerce-giftcards-add-form-field-validity-presets-2099-label": "2099",
    "commerce-giftcards-add-form-field-customerName-label": "jméno",
    "commerce-giftcards-add-form-field-customerEmail-label": "e-mail",
    "commerce-giftcards-add-form-field-customerPhone-label": "telefon",
    "commerce-giftcards-add-form-field-note-label": "poznámka",
    "commerce-giftcards-add-form-field-note-caption": "interní poznámka, neviditelná pro zákazníky",
    "commerce-giftcards-add-form-action-save-label": "uložit",
    "commerce-giftcards-add-form-action-cancel-label": "zrušit",

    "commerce-giftcards-transact-form-title": "Transakce",
    "commerce-giftcards-transact-form-direction-subtract": "odečíst",
    "commerce-giftcards-transact-form-direction-add": "přičíst",
    "commerce-giftcards-transact-form-amount-label": "částka",
    "commerce-giftcards-transact-form-amount-placeholder": "1000",
    "commerce-giftcards-transact-form-note-label": "poznámka",
    "commerce-giftcards-transact-form-note-placeholder": "K objednávce lala-123",
    "commerce-giftcards-transact-form-note-caption": "interní, neviditelná pro zákazníky",
    "commerce-giftcards-transact-form-actions-cancel-label": "zrušit",
    "commerce-giftcards-transact-form-actions-transact-subtract-label": "odečíst",
    "commerce-giftcards-transact-form-actions-transact-add-label": "přičíst",
    "commerce-giftcards-transact-form-actions-transactConfirm-label": "potvrdit",

    // commerce setup
    // invoicing
    "commerce-setup-company-title-invoicing": "Fakturace",
    "commerce-setup-company-label-orderNumberFormat": "Formát čísla faktury",

    // invoice info
    "commerce-setup-company-title-company": "Údaje na fakturu",
    "commerce-setup-company-label-name": "Firma",
    "commerce-setup-company-label-ico": "IČO",
    "commerce-setup-company-label-dic": "DIČ",
    "commerce-setup-company-label-legalNote": "Poznámka",

    // address
    "commerce-setup-company-label-street": "Ulice",
    "commerce-setup-company-label-streetNumber": "č.p.",
    "commerce-setup-company-label-city": "Město",
    "commerce-setup-company-label-postal": "PSČ",
    "commerce-setup-company-label-country": "Země",

    // banking
    "commerce-setup-company-label-bankName": "Název banky",
    "commerce-setup-company-label-bankCode": "Kód banky",
    "commerce-setup-company-label-accountNumber": "Číslo účtu",
    "commerce-setup-company-label-iban": "IBAN",
    "commerce-setup-company-label-swift": "SWIFT",

    // contact
    "commerce-setup-company-label-phone": "Telefon",
    "commerce-setup-company-label-email": "E-mail",

    "commerce-settings-general-shop-name": "Název obchodu",
    "commerce-settings-payment-taxes": "DPH [%]",

    "commerce-orders-hide-column": "Schovat sloupec",
    "commerce-orders-select-multiple": "Vybrat objednávky",
    "commerce-orders-cancel-selection": "Zrušit výběr",
    "commerce-orders-select-all-column": "Vybrat vše ve sloupci",
    "commerce-orders-of-selected": "vybrané",
    "commerce-orders-of-all": "všechny",
    // "commerce-orders" : "",
    // "commerce-orders" : "",

    "commerce-courier-liftago-courierPosition": "Lokace kurýra",
    "commerce-courier-liftago-rideStatus-PROCESSING": "Hledání řidiče",
    "commerce-courier-liftago-rideStatus-ACCEPTED": "Přijato řidičem",
    "commerce-courier-liftago-rideStatus-WAITING": "Řidič čeká na převzetí",
    "commerce-courier-liftago-rideStatus-IN_PROGRESS": "Naloženo na rozvoz",
    "commerce-courier-liftago-rideStatus-COMPLETED": "Doručeno",
    "commerce-courier-liftago-rideStatus-CANCELLED": "Zrušeno",
    "commerce-courier-liftago-rideStatus-REJECTED": "Žádný řidič k dispozici",
    "commerce-courier-liftago-stopState-IN_QUEUE": "Doručuje se",
    "commerce-courier-liftago-stopState-DELIVERED": "Doručeno",
    "commerce-courier-liftago-stopState-UNDELIVERED": "Nedoručeno",
    "commerce-courier-liftago-handoverStatus-NEW": "Zpracováno",
    "commerce-courier-liftago-handoverStatus-SCHEDULED": "Naplánováno",
    "commerce-courier-liftago-handoverStatus-IN_RIDE": "Čeká na vyzvednutí",
    "commerce-courier-liftago-handoverStatus-ON_BOARD": "Na cestě",
    "commerce-courier-liftago-handoverStatus-DELIVERING": "Doručuje se",
    "commerce-courier-liftago-handoverStatus-DELIVERED": "Doručeno",
    "commerce-courier-liftago-handoverStatus-UNDELIVERED": "Nedoručeno",
    "commerce-courier-liftago-handoverStatus-RETURNING": "Vrací se",
    "commerce-courier-liftago-handoverStatus-RETURNED": "Vráceno",
    "commerce-courier-liftago-handoverStatus-CANCELED": "Zrušeno",
    "commerce-courier-liftago-handoverStatus-CANCELED_IN_RIDE": "Zrušeno při vyzvednutí",
    "commerce-courier-liftago-handoverStatus-CANCELED_WITH_POB": "Zrušeno po naložení",
    "commerce-courier-liftago-handoverStatus-CANCELED_BY_DRIVER": "Zrušeno řidičem",
    "commerce-courier-liftago-handoverStatus-WONT_DELIVER": "Nedoručitelné",

    "commerce-override-detail-page": "Přetížit stránku detailu",
    "commerce-inventory-table-col-image": "obrázek",
    "commerce-inventory-table-col-title": "název",
    "commerce-inventory-table-col-type": "typ",
    "commerce-inventory-table-col-type-option-main": "hlavní",
    "commerce-inventory-table-col-type-option-variant": "varianta",
    "commerce-inventory-table-col-sku": "SKU",
    "commerce-inventory-table-col-price": "cena",
    "commerce-inventory-table-col-vat": "DPH",
    "commerce-inventory-table-col-stock-stocked": "skladem",
    "commerce-inventory-table-col-stock-available": "dostupné",
    "commerce-inventory-table-col-stock-reserved": "rezervované",
    "commerce-inventory-table-col-stock-blocked": "blokované",
    "commerce-inventory-table-col-tags": "štítky",
    "commerce-inventory-table-col-delivery-methods": "doručení",
    "commerce-inventory-table-col-kind": "kategorie",
    "commerce-inventory-table-col-kind-option-physical": "fyzický",
    "commerce-inventory-table-col-kind-option-virtual": "elektronický",
    "commerce-inventory-table-col-kind-option-no-delivery": "bez doručení",
    "commerce-inventory-table-col-subkind": "podkategorie",
    "commerce-inventory-table-col-subkind-option-booking": "rezervace",
    "commerce-inventory-table-col-subkind-option-giftCard": "dárková karta",
    "commerce-inventory-table-col-subkind-option-video-on-demand": "video",
    "commerce-inventory-table-col-subkind-option-digital-product": "digitální produkt",
    "commerce-inventory-table-col-visibility": "viditelnost",
    "commerce-inventory-table-col-visibility-option-auto": "podle skladu",
    "commerce-inventory-table-col-visibility-option-available": "dostupný",
    "commerce-inventory-table-col-visibility-option-unavailable": "nedostupný",
    "commerce-inventory-table-col-visibility-option-preorder": "předprodej",
    "commerce-inventory-table-col-visibility-option-hide": "skrytý",
    "commerce-inventory-table-col-whenUnavailable": "viditelnost vyprodáno",
    "commerce-inventory-table-col-whenUnavailable-option-restrict": "zakázat",
    "commerce-inventory-table-col-whenUnavailable-option-preorder": "předprodej",
    "commerce-inventory-table-col-whenUnavailable-option-hide": "skýt",
    "commerce-inventory-table-col-created": "vytvořeno",
    "commerce-inventory-table-col-updated": "upraveno",
    "commerce-inventory-price-kind-option-fixed": "standardní",
    "commerce-inventory-price-kind-option-package": "balíček",
    "commerce-inventory-price-kind-option-voluntary": "dobrovolná",
    "commerce-inventory-images-panel-variant-label": "varianta",
    "commerce-inventory-images-panel-listing-label": "seznam",
    "commerce-inventory-panel-settings-allowDispatchToCustomer-label": "vytisknu a předám",
    "commerce-inventory-panel-settings-allowDispatchToRecipient-label":
      "Ihned odeslat e-mailem příjemci",
    "commerce-inventory-panel-settings-giftCardTitle-label": "zobrazit",
    "commerce-inventory-panel-settings-giftCardTitle-option-amount": "částku",
    "commerce-inventory-panel-settings-giftCardTitle-option-product": "produkt",
    "commerce-inventory-panel-settings-pdf-title-label": "nadpis",
    "commerce-inventory-panel-settings-pdf-subtitle-label": "podnadpis",
    "commerce-inventory-panel-settings-pdf-description-label": "popis služby/produktu",
    "commerce-inventory-panel-settings-pdf-contactLine1-label": "kontakt - řádek 1",
    "commerce-inventory-panel-settings-pdf-contactLine2-label": "kontakt - řádek 2",
    "commerce-inventory-panel-settings-giftCardCodeKind-label": "typ kódu",
    "commerce-inventory-panel-settings-giftCardCodeKind-option-auto": "automaticky",
    "commerce-inventory-panel-settings-giftCardCodeKind-option-predefined": "ze seznamu",
    "commerce-inventory-panel-settings-giftCardCodeKind-predefined-warning":
      "Nezapomeňte přidat vlastní kódy do seznamu kódů",
    "commerce-inventory-panel-settings-giftCardCodeKind-expirationKind-label": "platnost",
    "commerce-inventory-panel-settings-giftCardCodeKind-expirationKind-option-fixed": "pevná",
    "commerce-inventory-panel-settings-giftCardCodeKind-expirationKind-option-floating": "plovoucí",
    "commerce-inventory-panel-settings-giftCardCodeKind-expirationKind-option-preset":
      "podle seznamu",
    "commerce-inventory-panel-settings-giftCardUsage-label": "použití",
    "commerce-inventory-panel-settings-giftCardUsage-option-offline": "umožnit použití v obchodě",
    "commerce-inventory-panel-settings-giftCardUsage-option-online": "umožnit použití na e-shopu",
    "commerce-inventory-panel-settings-giftCardUsage-option-credit":
      "umožnit použití vícekrát (odepisovatelná)",
    "commerce-inventory-panel-settings-giftCardUsage-option-expirationKind-label": "platnost",
    "commerce-inventory-panel-settings-giftCardUsage-option-expirationKind-option-fixed": "pevná",
    "commerce-inventory-panel-settings-giftCardUsage-option-expirationKind-option-floating":
      "plovoucí",
    "commerce-inventory-panel-settings-giftCardDaysValidFromPurchase-label": "dny platné od nákupu",
    "commerce-inventory-panel-settings-giftCardBonus-label": "bonus",
    "commerce-inventory-panel-settings-giftCardBonus-description":
      "Bonusová částka, která bude přidána k zůstatku dárkové karty po zaplacení objednávky. (např. prodej za 100 s bonusem 55 -> zákazník dostane 155). Poukaz zobrazí 155 (pokud je zobrazení nastaveno na částku).",

    // identity: companies
    "identity-companies-col-label-name": "název",
    "identity-companies-col-label-created": "vytvořeno",
    "identity-companies-col-label-updated": "upraveno",
    "identity-companies-add-form-title": "Nová firma",
    "identity-companies-add-form-field-name-label": "název",
    "identity-companies-add-form-field-note-label": "poznámka",
    "identity-companies-add-form-field-note-caption": "interní, neviditelná pro zákazníky",
    "identity-companies-add-form-action-save-label": "uložit",
    "identity-companies-add-form-action-cancel-label": "zrušit",

    // identity: persons
    "identity-persons-col-label-nameFirst": "jméno",
    "identity-persons-col-label-nameLast": "příjmení",
    "identity-persons-col-label-email": "e-mail",
    "identity-persons-col-label-phone": "telefon",
    "identity-persons-col-label-birthday": "datum narození",
    "identity-persons-col-label-stampCards": "razítkové karty",
    "identity-persons-col-label-receiveNews": "přijímání novinek",
    "identity-persons-col-label-created": "vytvořeno",
    "identity-persons-col-label-updated": "upraveno",
    "identity-persons-add-form-title": "Nová osoba",
    "identity-persons-add-form-field-nameFirst-label": "jméno",
    "identity-persons-add-form-field-nameLast-label": "příjmení",
    "identity-persons-add-form-field-email-label": "e-mail",
    "identity-persons-add-form-field-phone-label": "telefon",
    "identity-persons-add-form-field-birthday-label": "datum narození",
    "identity-persons-add-form-field-receiveNews-label": "přijímání novinek",
    "identity-persons-add-form-field-companies-label": "firmy",
    "identity-persons-add-form-field-note-label": "poznámka",
    "identity-persons-add-form-field-note-caption": "interní, neviditelná pro zákazníky",
    "identity-persons-add-form-action-save-label": "uložit",
    "identity-persons-add-form-action-cancel-label": "zrušit",
    "identity-persons-detail-edit-label": "upravit",
    "identity-persons-detail-discounts-label": "slevy",
    "identity-persons-detail-discounts-none": "žádné slevy přiřazeny",
    "identity-persons-detail-cashbacks-label": "cashbacky",
    "identity-persons-detail-cashbacks-none": "žádné cashbacky přiřazeny",
    "identity-persons-detail-topup-bonuses-label": "bonusy za připisání",
    "identity-persons-detail-topup-bonuses-none": "žádné bonusy za připisání přiřazeny",
    "identity-persons-detail-entitlements-label": "nosiče",
    "identity-persons-detail-entitlements-none": "žádné nosiče propojeny",

    "list-overview-count": "počet",
    "list-overview-count-selected": "počet (vybrané)",

    // balances
    "balance-balances-overview-total-available": "Σ zůstatek",
    "balance-balances-overview-lifetime-credit": "Σ připsáno",
    "balance-balances-overview-lifetime-debit": "Σ odepsáno",
    "balance-balances-col-label-name": "název",
    "balance-balances-col-label-balanceGroupId": "skupina",
    "balance-balances-col-label-company": "firma",
    "balance-balances-col-label-persons": "osoby",
    "balance-balances-col-label-available": "zůstatek",
    "balance-balances-col-label-currency": "měna",
    "balance-balances-col-label-status": "stav",
    "balance-balances-col-label-allowCredit": "připisování",
    "balance-balances-col-label-allowDebit": "odepisování",
    "balance-balances-col-label-allowDebitPartial": "částečné odepisování",
    "balance-balances-col-label-ruleLimits": "limity",
    "balance-balances-col-label-ruleChannels": "kanály",
    "balance-balances-col-label-lifetimeCredit": "Σ připsáno",
    "balance-balances-col-label-lifetimeDebit": "Σ odepsáno",
    "balance-balances-col-label-activeFrom": "platnost od",
    "balance-balances-col-label-activeTo": "platnost do",
    "balance-balances-col-label-created": "vytvořeno",
    "balance-balances-col-label-updated": "upraveno",
    "balance-balances-filter-title": "Filtrovat účty",
    "balance-balances-filter-created-from": "Vytvořeno od",
    "balance-balances-filter-created-to": "Vytvořeno do",
    "balance-balances-filter-button": "Filtr",
    "balance-balances-col-value-status-inactive": "neaktivní",
    "balance-balances-col-value-status-active": "aktivní",
    "balance-balances-col-value-status-locked": "zamčen",
    "balance-balances-col-value-status-suspended": "pozastaven",
    "balance-balances-col-value-status-expired": "vypršel",
    "balance-balances-col-value-status-closed": "zrušen",
    "balance-balance-detail-overview-available-label": "zůstatek",
    "balance-balance-detail-overview-lifetime-credit-label": "Σ připsáno",
    "balance-balance-detail-overview-lifetime-debit-label": "Σ odepsáno",
    "balance-balance-detail-overview-currency-label": "měna",
    "balance-balance-detail-overview-persons-label": "osoby",
    "balance-balance-detail-overview-active-from": "platnost od",
    "balance-balance-detail-overview-active-to": "platnost do",
    "balance-balance-detail-overview-capabilities-label": "vlastnosti",
    "balance-balance-detail-overview-capabilities-allowCredit-label": "připisování",
    "balance-balance-detail-overview-capabilities-allowDebit-label": "odepisování",
    "balance-balance-detail-overview-capabilities-allowDebitPartial-label": "odepisování částečné",
    "balance-balance-detail-overview-merchantNote-label": "poznámky",
    "balance-balance-detail-overview-ruleLimits-label": "limity",
    "balance-balance-detail-overview-ruleLimits-noLimits": "žádné limity",
    "balance-balance-detail-overview-ruleLimits-table-col-type": "typ",
    "balance-balance-detail-overview-ruleLimits-table-col-period": "období",
    "balance-balance-detail-overview-ruleLimits-table-col-amountMin": "min",
    "balance-balance-detail-overview-ruleLimits-table-col-amountMax": "max",
    "balance-balance-detail-overview-ruleLimits-table-col-setter": "nastavil",
    "balance-balance-detail-overview-ruleLimits-table-row-setter-merchant": "obchodník",
    "balance-balance-detail-overview-ruleLimits-table-row-setter-customer": "zákazník",
    "balance-balance-detail-overview-ruleChannels-label": "kanály",
    "balance-balance-detail-overview-ruleChannels-noChannels":
      "⚠️ žádné kanály - odepisovat lze jen v administraci",
    "balance-balance-detail-overview-entitlements-label": "nosiče",
    "balance-balance-detail-transactions-label": "transakce",
    "balance-balance-detail-transactions-expiration-adjustment-note": "Expirovaný kredit",
    "balance-balance-detail-transactions-created-by-system": "Systém",

    "balance-balance-detail-history-label": "historie",
    "balance-balance-detail-history-action-active_to_change": "změna platnosti do",
    "balance-balance-detail-history-action-active_from_change": "změna platnosti od",
    "balance-balance-detail-history-action-status_change": "změna stavu",

    "balance-balance-detail-dialog-active-to-title": "Změna platnosti do",
    "balance-balance-detail-dialog-active-to-field-label": "platnost do",
    "balance-balance-detail-dialog-active-to-end-of-day-label": "konec dne",
    "balance-balance-detail-dialog-active-to-button-confirm-label": "potvrdit",
    "balance-balance-detail-dialog-active-to-note-merchant-label": "poznámka",
    "balance-balance-detail-dialog-active-to-note-merchant-placeholder": "důvod prodloužení",
    "balance-balance-detail-dialog-active-to-note-merchant-caption": "interní, neviditelná pro zákazníky",
    "balance-balance-detail-dialog-active-to-note-customer-label": "poznámka pro zákazníka",
    "balance-balance-detail-dialog-active-to-note-customer-placeholder": "prodlouženo na vaši žádost",
    "balance-balance-detail-dialog-active-to-note-customer-caption": "viditelná pro zákazníka",
    "balance-balance-detail-dialog-active-to-note-platform-label": "poznámka platformy",
    "balance-balance-detail-dialog-active-to-note-platform-placeholder": "interní",
    "balance-balance-detail-dialog-active-to-note-platform-caption": "pouze pro platform adminy",
    "balance-balance-detail-dialog-active-to-reactivate-hint-expired": "Vypršelo — znovu aktivovat?",
    "balance-balance-detail-dialog-active-to-reactivate-hint-inactive": "Neaktivované — aktivovat?",
    "balance-balance-detail-dialog-active-to-reactivate-switch-label": "Aktivovat",
    "balance-balance-detail-history-note-platform-label": "poznámka platformy",

    "balance-balance-detail-dialog-status-title": "Změna stavu",
    "balance-balance-detail-dialog-status-button-cancel-label": "zrušit",
    "balance-balance-detail-dialog-status-button-save-label": "nastavit",

    "balance-add-form-group-title": "Vytvořit skupinu kont",
    "balance-add-form-group-description":
      "Skupiny kont slouží ke sdružení jednotlivých kont. Nosiče (Mobilní karty a Poukazy) jsou přidruženy skupinám kont. Osobám jsou vydávány Nosiče, aby mohli utrácet z více kont v rámci jedné transakce.",

    "balance-add-form-single-title": "Vytvořit konto",
    "balance-add-form-single-description":
      "Nosiče (Mobilní karty a Poukazy) jsou přidruženy kontu. Osobám jsou vydávány Nosiče.",

    "balance-balances-label": "Konta",
    "balance-add-form-balances-group-label": "Konta",
    "balance-add-form-balances-group-item-label": "Konto",
    "balance-add-form-balances-group-add": "Konto",
    "balance-add-form-balances-group-caption":
      "Konta jsou seřazena podle priority pro odepisování.",
    "balance-add-form-linkPerson-button-label": "Přiřadit osobu",
    "balance-add-form-linkPerson-button-caption-group":
      "Vyberte osobu, která bude moci nakládat s touto skupinou kont. Obvykle jde o vašeho zákazníka.",
    "balance-add-form-linkPerson-button-caption-single":
      "Vyberte osobu, která bude moci kontem nakládat. Obvykle jde o vašeho zákazníka.",
    "balance-add-form-linkPerson-select-label": "Osoba",
    "balance-add-form-linkPerson-select-option-label-add": "Nová osoba",
    "balance-add-form-displayCode-label": "Zobrazit kód po vytvoření",
    "balance-add-form-created-code-dialog-title": "Vytvořený kód",
    "balance-add-form-created-code-dialog-button-close-label": "Zavřít",
    "balance-add-form-entitlements-heading": "Nosiče",
    "balance-add-form-entitlements-description":
      "Vydejte Nosiče, které umožní Osobě nakládat s touto skupinou kont.",
    "balance-add-form-entitlements-online-label": "Online portál",
    "balance-add-form-entitlements-online-caption":
      "Zákaznická zóna na vašem webu (vyžaduje osobu)",
    "balance-add-form-entitlements-card-label": "Fyzická karta",
    "balance-add-form-entitlements-card-caption": "Fyzická karta",
    "balance-add-form-entitlements-pass-label": "Mobilní karta",
    "balance-add-form-entitlements-pass-caption":
      "Lístek v Apple / Google Peněžence (vyžaduje osobu)",
    "balance-add-form-entitlements-voucher-label": "Poukaz",
    "balance-add-form-entitlements-voucher-caption": "PDF poukaz",
    "balance-add-form-entitlements-voucherTemplate-label": "Šablona",
    "balance-add-form-entitlements-provideCustomCode-label": "Vlastní kód",
    "balance-add-form-entitlements-provideCustomCode-caption": "Vydejte Nosič s vlastním kódem",
    "balance-add-form-entitlements-customCode-caption":
      "8+ znaků mix A-Z0-9 doporučeno. Žádné mezery nebo speciální znaky.",
    "balance-add-form-entitlements-dispatch-label": "Poslat e-mailem",
    "balance-add-form-entitlements-dispatch-caption":
      "Poslat Nosiče vybrané osobě e-mailem po vytvoření. (vyžaduje osobu)",
    "balance-add-form-balance-heading": "Konto",
    "balance-add-form-balance-form-status-label": "Stav",
    "balance-add-form-balance-form-status-option-inactive-label": "Neaktivní",
    "balance-add-form-balance-form-status-option-active-label": "Aktivní",
    "balance-add-form-balance-form-status-option-locked-label": "Zamčené",
    "balance-add-form-balance-form-status-option-suspended-label": "Pozastavené",
    "balance-add-form-balance-form-status-option-expired-label": "Expirované",
    "balance-add-form-balance-form-status-option-closed-label": "Zrušené",
    "balance-add-form-balance-form-linkCompany-button-label": "Přiřadit firmu",
    "balance-add-form-balance-form-linkCompany-button-caption":
      "Pro vaši referenci, pokud je toto konto přidruženo k firmě (např. vašemu B2B klientovi).",
    "balance-add-form-balance-form-linkCompany-select-label": "Firma",
    "balance-add-form-balance-form-linkCompany-select-option-label-add": "Nová firma",
    "balance-add-form-balance-form-nameCustomer-label": "Název pro zákazníka",
    "balance-add-form-balance-form-nameCustomer-placeholder": "Pracovní",
    "balance-add-form-balance-form-nameCustomer-caption": "Zákazník vidí v online portálu.",
    "balance-add-form-balance-form-nameMerchant-label": "Název",
    "balance-add-form-balance-form-nameMerchant-placeholder": "GoodCompany llc.",
    "balance-add-form-balance-form-nameMerchant-caption": "Interní, neviditelné pro zákazníka",
    "balance-add-form-balance-form-activePeriod-label": "Aktivní",
    "balance-add-form-balance-form-activePeriod-caption": "Platnost od aktivace",
    "balance-add-form-balance-form-validityPeriod-label": "Platnost",
    "balance-add-form-balance-form-validityPeriod-caption": "Platnost začíná při aktivaci",
    "balance-add-form-balance-form-activeFrom-label": "Od",
    "balance-add-form-balance-form-activeFrom-caption": "zobrazuje časové pásmo zdroje",
    "balance-add-form-balance-form-activeTo-label": "Do",
    "balance-add-form-balance-form-activeTo-caption": "zobrazuje časové pásmo zdroje",

    "balance-add-form-balance-form-capabilities-heading": "Vlastnosti",
    "balance-add-form-balance-form-capabilities-allowCredit-label": "Připisování",
    "balance-add-form-balance-form-capabilities-allowCredit-caption": "Osoba může konto dobíjet",
    "balance-add-form-balance-form-capabilities-allowDebit-label": "Odepisování",
    "balance-add-form-balance-form-capabilities-allowDebit-caption": "Z konta lze odepsat",
    "balance-add-form-balance-form-capabilities-allowDebitPartial-label": "Částečné",
    "balance-add-form-balance-form-capabilities-allowDebitPartial-caption":
      "Z konta lze odepsat vícekrát",

    "balance-add-form-balance-form-channels-label": "Kanály",
    "balance-add-form-balance-form-channels-caption": "Vyberte kanály, kde lze konto použít",
    "balance-add-form-balance-form-limits-heading": "Limity",
    "balance-add-form-balance-form-limits-form-type-label": "Typ",
    "balance-add-form-balance-form-limits-form-type-option-credit-label": "Připsat",
    "balance-add-form-balance-form-limits-form-type-option-debit-label": "Odepsat",
    "balance-add-form-balance-form-limits-form-type-option-expiration_adjustment-label":
      "Upravit platnost",
    "balance-add-form-balance-form-limits-form-period-label": "Období",
    "balance-add-form-balance-form-limits-form-period-option-lifetime-label": "Celoživotní",
    "balance-add-form-balance-form-limits-form-period-option-year-label": "Rok",
    "balance-add-form-balance-form-limits-form-period-option-month-label": "Měsíc",
    "balance-add-form-balance-form-limits-form-period-option-week-label": "Týden",
    "balance-add-form-balance-form-limits-form-period-option-day-label": "Den",
    "balance-add-form-balance-form-limits-form-period-option-hour-label": "Hodina",
    "balance-add-form-balance-form-limits-form-period-option-balance_available-label":
      "Dostupný zůstatek",
    "balance-add-form-balance-form-limits-form-period-option-transaction-label": "Transakce",

    "balance-add-form-balance-form-limits-form-amountMin-label": "Min",
    "balance-add-form-balance-form-limits-form-amountMin-placeholder": "0",
    "balance-add-form-balance-form-limits-form-amountMax-label": "Max",
    "balance-add-form-balance-form-limits-form-amountMax-placeholder": "1000",
    "balance-add-form-balance-form-limits-form-actions-add-label": "přidat",
    "balance-add-form-balance-form-limits-form-actions-remove-label": "odstranit",
    "balance-add-form-balance-form-available-label": "Částka",
    "balance-add-form-balance-form-amount-mode-label": "Částka",
    "balance-add-form-balance-form-amount-mode-option-flexible-label": "Flexibilní",
    "balance-add-form-balance-form-amount-mode-option-flexible-caption": "Nastaví se při aktivaci",
    "balance-add-form-balance-form-amount-mode-option-fixed-label": "Pevná",
    "balance-add-form-balance-form-transactionDescription-label": "Popis transakce",
    "balance-add-form-balance-form-transactionDescription-placeholder": "Roční stravné do kantýny",
    "balance-add-form-balance-form-transactionDescription-caption":
      "Zobrazí se v historii transakcí",
    "balance-add-form-balance-form-note-label": "Poznámka",
    "balance-add-form-balance-form-note-caption": "Interní, neviditelná pro zákazníky",
    "balance-add-form-balance-form-actions-save-label": "uložit",
    "balance-add-form-balance-form-actions-cancel-label": "zrušit",
    "balance-add-form-balance-form-actions-cancel-label-confirm": "potvrdit",

    "balance-add-form-actions-create-label": "vytvořit",
    "balance-add-form-actions-cancel-label": "zrušit",
    "balance-add-form-actions-cancel-label-secondary": "potvrdit",

    "balance-transact-form-title": "Transakce",
    "balance-transact-form-status-inactive-label": "neaktivní",
    "balance-transact-form-status-active-label": "aktivní",
    "balance-transact-form-status-locked-label": "zamčený",
    "balance-transact-form-status-suspended-label": "pozastavený",
    "balance-transact-form-status-expired-label": "expirovaný",
    "balance-transact-form-status-closed-label": "zavřený",
    "balance-transact-form-type-debit": "odepsat",
    "balance-transact-form-type-credit": "připsat",
    "balance-transact-form-amount-label": "částka",
    "balance-transact-form-amount-placeholder": "1000",
    "balance-transact-form-description-label": "popis",
    "balance-transact-form-description-placeholder": "K objednávce lala-123",
    "balance-transact-form-description-caption": "sdíleno se zákazníkem",
    "balance-transact-form-note-merchant-label": "poznámka",
    "balance-transact-form-note-merchant-placeholder": "odsouhlaseno s šéfem dne 2025-01-01",
    "balance-transact-form-note-merchant-caption": "interní, neviditelná pro zákazníky",
    "balance-transact-form-actions-cancel-label": "zrušit",
    "balance-transact-form-actions-transact-debit-label": "odepsat",
    "balance-transact-form-actions-transact-credit-label": "připsat",
    "balance-transact-form-actions-transactConfirm-label": "potvrdit",
    "balance-transact-form-bulk-header-count": "Vybráno %0 účtů",
    "balance-transact-form-bulk-header-total": "Celkem",
    "balance-balances-bulk-transact-button": "Hromadná transakce",
    "balance-transact-form-bulk-success": "Transakce provedena na %0 účtech",

    "balance-activate-form-title": "Aktivace",
    "balance-activate-form-status-inactive-label": "neaktivní",
    "balance-activate-form-status-active-label": "aktivní",
    "balance-activate-form-status-locked-label": "zamčený",
    "balance-activate-form-status-suspended-label": "pozastavený",
    "balance-activate-form-status-expired-label": "expirovaný",
    "balance-activate-form-status-closed-label": "zavřený",
    "balance-activate-form-amount-label": "částka",
    "balance-activate-form-amount-placeholder": "1000",
    "balance-activate-form-description-label": "popis",
    "balance-activate-form-description-placeholder": "K objednávce lala-123",
    "balance-activate-form-description-caption": "sdíleno se zákazníkem",
    "balance-activate-form-note-merchant-label": "poznámka",
    "balance-activate-form-note-merchant-placeholder": "odsouhlaseno s šéfem dne 2025-01-01",
    "balance-activate-form-note-merchant-caption": "interní, neviditelná pro zákazníky",
    "balance-activate-form-active-to-label": "platné do",
    "balance-activate-form-active-to-placeholder": "vyberte datum",
    "balance-activate-form-active-to-caption": "datum a čas expirace",
    "balance-activate-form-actions-transact-activate-label": "aktivovat",
    "balance-activate-form-actions-transactConfirm-label": "potvrdit",
    "balance-activate-form-actions-cancel-label": "zrušit",

    "booking-status-awaiting_payment": "čeká na platbu",
    "booking-status-awaiting_confirmation": "čeká na potvrzení",
    "booking-status-confirmed": "potvrzeno",
    "booking-status-in_progress": "probíhá",
    "booking-status-completed": "dokončeno",
    "booking-status-no_show": "nedorazil",
    "booking-status-cancelled": "zrušeno",

    "booking-resources-add-label": "zdroj",
    "booking-resources-table-col-name": "název",
    "booking-resources-table-col-type": "typ",
    "booking-resources-table-col-timezone": "časové pásmo",

    "booking-resources-add-form-field-name-label": "název",
    "booking-resources-add-form-field-name-caption":
      "název místnosti nebo osoby, kde nebo u které je služba plněna. pro vnitřní referenci, neviditelné pro zákazníky.",
    "booking-resources-add-form-field-type-label": "typ",
    "booking-resources-add-form-field-type-option-venue-label": "místo",
    "booking-resources-add-form-field-type-option-person-label": "osoba",
    "booking-resources-add-form-field-timezone-label": "časové pásmo",
    "booking-resources-add-form-action-save-label": "uložit",
    "booking-resources-add-form-action-cancel-label": "zrušit",

    "booking-services-add-button-label": "služba",
    "booking-services-table-col-name": "název",
    "booking-services-table-col-duration": "doba trvání (min)",
    "booking-services-table-col-paid": "placená",
    "booking-services-table-col-description": "popis",

    "booking-services-add-form-field-name-label": "název",
    "booking-services-add-form-field-name-caption":
      "pro vnitřní referenci, neviditelné pro zákazníky",
    "booking-services-add-form-field-description-label": "popis",
    "booking-services-add-form-field-description-caption":
      "pro vnitřní referenci, neviditelné pro zákazníky",
    "booking-services-add-form-field-duration-label": "doba trvání (min)",
    "booking-services-add-form-field-duration-caption":
      "použito pro předvyplnění délky slotu při plánování",
    "booking-services-add-form-field-paid-label": "placená",
    "booking-services-add-form-action-save-label": "uložit",
    "booking-services-add-form-action-cancel-label": "zrušit",

    "booking-slots-add-button-label": "slot",
    "booking-slots-table-col-date": "datum",
    "booking-slots-table-col-start": "začátek",
    "booking-slots-table-col-end": "konec",
    "booking-slots-table-col-capacity": "kapacita",
    "booking-slots-table-col-remaining": "zbývá",
    "booking-slots-table-col-reservations": "rezervace",
    "booking-slots-table-col-capacity-limited-by": "omezeno",
    "booking-slots-table-col-resource": "zdroj",
    "booking-slots-table-col-services": "služby",
    "booking-slots-table-col-capacity-limited-by-option-count": "počet",
    "booking-slots-table-col-capacity-limited-by-option-minutes": "minuty",

    "booking-slots-form-field-has-reservations-caption":
      "Slot has reservations -> only total capacity can be modified.",
    "booking-slots-form-field-resource-label": "zdroj",
    "booking-slots-form-field-start-label": "začátek",
    "booking-slots-form-field-start-caption": "zobrazuje časové pásmo zdroje",
    "booking-slots-form-field-end-label": "konec",
    "booking-slots-form-field-end-caption": "zobrazuje časové pásmo zdroje",
    "booking-slots-form-field-capacity-limited-by-label": "omezení",
    "booking-slots-form-field-capacity-limited-by-option-count": "počet",
    "booking-slots-form-field-capacity-limited-by-option-minutes": "minuty",
    "booking-slots-form-field-services-label": "služby",
    "booking-slots-form-field-services-caption": "služby, které mohou tento slot obsadit",
    "booking-slots-form-field-capacity-label": "kapacita",
    "booking-slots-form-action-save-label": "uložit",
    "booking-slots-form-action-cancel-label": "zrušit",

    "booking-reservations-add-button-label": "rezervace",
    "booking-reservations-send-reminder-button-label": "poslat upomínku",
    "booking-reservations-send-reminder-button-label-secondary": "potvrdit",
    "booking-reservations-change-status-button-label": "změnit stav",
    "booking-reservations-change-status-dialog-title": "změna stavu",
    "booking-reservations-change-status-dialog-button-label": "změnit",
    "booking-reservations-table-col-name": "jméno",
    "booking-reservations-table-col-code": "kód",
    "booking-reservations-table-col-capacity": "kapacita",
    "booking-reservations-table-col-status": "stav",
    "booking-reservations-table-col-service": "služba",
    "booking-reservations-table-col-date": "datum",
    "booking-reservations-table-col-slot": "slot",
    "booking-reservations-table-col-email": "e-mail",
    "booking-reservations-table-col-phone": "telefon",
    "booking-reservations-table-col-customer-note": "poznámka zákazníka",
    "booking-reservations-table-col-extra": "extra",

    "booking-reservations-form-field-service-label": "služba",
    "booking-reservations-form-field-slot-label": "slot",
    "booking-reservations-form-field-status-label": "stav",
    "booking-reservations-form-field-capacity-label": "kapacita",
    "booking-reservations-form-field-customer-name-label": "jméno",
    "booking-reservations-form-field-customer-email-label": "e-mail",
    "booking-reservations-form-field-customer-phone-label": "telefon",
    "booking-reservations-form-field-confirmed-by-vendor-label": "potvrzeno obchodníkem",
    "booking-reservations-form-field-confirmed-by-vendor-caption":
      "Rezervace je považována za potvrzenou ze strany obchodníka.",
    "booking-reservations-form-field-confirmed-by-customer-label": "potvrzeno zákazníkem",
    "booking-reservations-form-field-confirmed-by-customer-caption":
      "Rezervace je považována za potvrzenou ze strany zákazníka. Když je objednána přes e-shop, je to po zaplacení.",
    "booking-reservations-form-field-customer-note-label": "poznámka zákazníka",
    "booking-reservations-form-field-customer-note-caption": "požadavky zákazníka",
    "booking-reservations-form-field-internal-note-label": "poznámka interní",
    "booking-reservations-form-field-internal-note-caption": "neviditelná pro zákazníka",
    "booking-reservations-form-field-preferred-language-label": "preferovaný jazyk",
    "booking-reservations-form-field-all-guests-are-adults-label": "všichni hosté jsou dospělí",
    "booking-reservations-form-action-save-label": "uložit",
    "booking-reservations-form-action-cancel-label": "zrušit",

    "billing-transactions-list-category-usage": "využití",
    "billing-transactions-list-category-top_up": "připsání",
    "billing-balance-available-label": "dostupný zůstatek",
    "billing-balance-top-up-title": "dobít kredit",
    "billing-balance-top-up-button-label": "dobít",
    "billing-balance-top-up-amount-label": "částka",
    "billing-balance-top-up-amount-placeholder": "1000",
    "billing-balance-top-up-amount-caption": "CZK",
    "billing-balance-top-up-amount-currency": "CZK",
    "billing-balance-top-up-amount-currency-placeholder": "CZK",
    "billing-balance-top-up-amount-currency-caption": "CZK",
    "billing-balance-available-after-label": "po připsání",
    "billing-balance-top-up-payment-message":
      "Pro zpracování plateb používáme Stripe. Údaje o vaší kartě nevidíme.",
    "billing-balance-top-up-invoice-notice":
      "Dobitá částka bude zohledněna na vaší měsíční faktuře na začátku příštího měsíce.",
    "billing-balance-top-up-actions-pay-label": "zaplatit",
    "billing-balance-top-up-actions-cancel-label": "zrušit",

    "billing-meters-title": "měřiče",
    "billing-meters-loading": "načítám...",
    "billing-meters-no-meters": "žádné měřiče",
    "billing-meters-table-col-product": "produkt",
    "billing-meters-table-col-price": "cena",
    "billing-meters-table-col-free-quota": "využitá kvóta",
    "billing-meters-table-col-operations": "operace",
    "billing-meters-table-col-free-quota-period": "za",
    "billing-meters-table-col-free-quota-period-day": "den",
    "billing-meters-table-col-free-quota-period-week": "týden",
    "billing-meters-table-col-free-quota-period-month": "měsíc",
    "billing-meters-table-col-free-quota-period-year": "rok",
    "billing-meters-table-col-free-quota-resets": "obnoví se",
    "billing-meters-table-col-billable": "účtované",
    "billing-meters-table-col-non-billable": "neúčtované",

    "billing-operation-estimate-title": "poplatek",
    "billing-operation-estimate-form-field-operation-name-label": "operace",
    "billing-operation-estimate-form-field-operation-fee-label": "sazba",
    "billing-operation-estimate-form-field-operation-fee-free-label": "zdarma",
    "billing-operation-estimate-form-field-operation-fee-per-unit-label": "sazba za jednotku",
    "billing-operation-estimate-form-field-operation-fee-total-label": "celkem",
    "billing-operation-estimate-form-field-operation-balance-label": "zůstatek",
    "billing-operation-estimate-form-field-operation-balance-top-up-button-label": "dobít",
    "billing-operation-estimate-form-field-operation-free-quota-left-label": "volná kvóta",

    "entitlement-entitlements-table-col-code": "kód",
    "entitlement-entitlements-table-col-type": "typ",
    "entitlement-entitlements-table-col-status": "stav",

    "entitlement-entitlements-table-col-balance": "zůstatek",
    "entitlement-entitlements-table-col-balance-status": "stav konta",
    "entitlement-entitlements-table-col-available-status": "stav zůstatku",
    "entitlement-entitlements-table-col-available": "zůstatek",
    "entitlement-entitlements-table-col-currency": "měna",
    "entitlement-entitlements-table-col-person": "osoba",
    "entitlement-entitlements-table-col-validFrom": "platnost od",
    "entitlement-entitlements-table-col-validTo": "platnost do",
    "entitlement-entitlements-table-col-lastUsedAt": "poslední použití",
    "entitlement-entitlements-table-col-lastDebitedAt": "poslední odpis",
    "entitlement-entitlements-table-col-createdAt": "nosič vytvořen",
    "entitlement-entitlements-table-col-balance-createdAt": "konto vytvořeno",
    "entitlement-entitlements-col-value-status-unused": "nepoužit",
    "entitlement-entitlements-col-value-status-linked": "přiřazen",
    "entitlement-entitlements-col-value-status-unlinked": "odpojen",
    "entitlement-entitlements-col-value-status-suspended": "pozastaven",
    "entitlement-entitlements-col-value-status-voided": "zrušen",
    "entitlement-entitlements-col-value-balance-status-inactive": "neaktivní",
    "entitlement-entitlements-col-value-balance-status-active": "aktivní",
    "entitlement-entitlements-col-value-balance-status-locked": "zamčen",
    "entitlement-entitlements-col-value-balance-status-suspended": "pozastaven",
    "entitlement-entitlements-col-value-balance-status-expired": "vypršel",
    "entitlement-entitlements-col-value-balance-status-closed": "zrušen",
    "entitlement-entitlements-col-value-available-status-full": "plný",
    "entitlement-entitlements-col-value-available-status-used": "použitý",
    "entitlement-entitlements-col-value-available-status-depleted": "vyčerpaný",
    "entitlement-entitlements-type-card": "karta",
    "entitlement-entitlements-type-pass": "pass",
    "entitlement-entitlements-type-voucher": "voucher",

    "entitlement-entitlements-detail-type-label": "typ",
    "entitlement-entitlements-detail-status-label": "stav",
    "entitlement-entitlements-detail-balance-name-untitled": "bez názvu",
    "entitlement-entitlements-detail-balance-label": "konto",
    "entitlement-entitlements-detail-balance-unlink-label": "odpojit",
    "entitlement-entitlements-detail-balance-unlink-label-confirm": "potvrdit",
    "entitlement-entitlements-detail-balance-link-label": "přiřadit",
    "entitlement-entitlements-detail-person-label": "osoba",
    "entitlement-entitlements-detail-order-label": "objednávka",
    "entitlement-entitlements-detail-pdf-label": "PDF",
    "entitlement-entitlements-detail-pdf-button-download-label": "stáhnout",
    "entitlement-entitlements-detail-history-label": "historie",
    "entitlement-entitlements-detail-status-unused": "nepoužit",
    "entitlement-entitlements-detail-status-linked": "přiřazen",
    "entitlement-entitlements-detail-status-unlinked": "odpojen",
    "entitlement-entitlements-detail-status-suspended": "pozastaven",
    "entitlement-entitlements-detail-status-voided": "zrušen",
    "entitlement-entitlements-detail-link-balance-form-title": "přiřadit konto",
    "entitlement-entitlements-detail-history-action-balance-link": "konto přiřazeno",
    "entitlement-entitlements-detail-history-action-balance-unlink": "konto odpojeno",
    "entitlement-entitlements-detail-history-action-card-create": "karta vytvořena",
    "entitlement-entitlements-detail-history-action-card-link": "karta přiřazena",
    "entitlement-entitlements-detail-history-action-card-unlink": "karta odpojena",
    "entitlement-entitlements-detail-history-action-card-transfer": "karta převedena",
    "entitlement-entitlements-detail-history-action-card-void": "karta zrušena",

    // entitlement: voucher templates
    "entitlement-voucher-templates-add-form-title": "vytvořit šablonu voucheru",
    "entitlement-voucher-templates-table-col-label-name": "název",
    "entitlement-voucher-templates-table-col-label-locale": "jazyk",
    "entitlement-voucher-templates-table-col-label-created": "vytvořeno",
    "entitlement-voucher-templates-add-form-name-label": "název",
    "entitlement-voucher-templates-add-form-name-placeholder": "obchodní partner Firma s.r.o.",
    "entitlement-voucher-templates-add-form-image-label": "obrázek",
    "entitlement-voucher-templates-add-form-message-label": "zpráva",
    "entitlement-voucher-templates-add-form-message-placeholder": "vše nejlepší",
    "entitlement-voucher-templates-add-form-message-caption":
      "zpráva na voucheru. použij [BR] pro zalomení řádku.",
    "entitlement-voucher-templates-add-form-title-label": "nadpis",
    "entitlement-voucher-templates-add-form-title-placeholder": "poukaz",
    "entitlement-voucher-templates-add-form-subtitle-label": "podnadpis",
    "entitlement-voucher-templates-add-form-subtitle-placeholder": "na služby",
    "entitlement-voucher-templates-add-form-product-name-label": "název produktu",
    "entitlement-voucher-templates-add-form-product-name-placeholder": "spa procedura",
    "entitlement-voucher-templates-add-form-product-name-caption":
      "použij [PRICE] pro zobrazení ceny produktu.",
    "entitlement-voucher-templates-add-form-product-description-label": "popis produktu",
    "entitlement-voucher-templates-add-form-product-description-placeholder":
      "relaxující masáž a wellness balíček",
    "entitlement-voucher-templates-add-form-product-description-caption":
      "použij [PRICE] pro zobrazení ceny produktu.",
    "entitlement-voucher-templates-add-form-footer-line-1-label": "patička 1",
    "entitlement-voucher-templates-add-form-footer-line-1-placeholder": "@priklad",
    "entitlement-voucher-templates-add-form-footer-line-2-label": "patička 2",
    "entitlement-voucher-templates-add-form-footer-line-2-placeholder": "priklad.cz",
    "entitlement-voucher-templates-add-form-footer-line-caption":
      "Šablonu po uložení nelze upravovat.",
    "entitlement-voucher-templates-add-form-save-label": "uložit",
    "entitlement-voucher-templates-add-form-preview-label": "náhled",
    "entitlement-voucher-templates-add-form-cancel-label": "zrušit",
    "entitlement-voucher-templates-add-form-cancel-label-secondary": "potvrdit",

    "address-street": "Ulice",
    "address-number": "Číslo popisné",
    "address-area": "Oblast",
    "address-city": "Město",
    "address-zip": "PSČ",
    "address-region": "Region",
    "address-country": "Země",
    "commerce-invoice-disclaimer": "Informativní text faktury",

    // cart labels for cart overrides form - if you change this, change the client translation file
    "cart-main-title": "Košík",
    "cart-header-backToShop": "Zpět do obchodu",
    "cart-itemList-empty": "Nic tu není. 😔 Něco si vyber 🙃",
    "cart-promoCode-title": "Slevový kód",
    "cart-promoCode-insert": "Použít slevový kód",
    "cart-promoCode-field-promoCode-label": "Máte kód slevového kódu?",
    "cart-promoCode-field-promoCode-placeholder":
      "Kouzelné heslo, které způsobí, že i při utrácení ušetříte. 😜",
    "cart-promoCode-field-promoCode-helpText": "ABRAKADABRA",
    "cart-delivery-title": "Doručení",
    "cart-delivery-branch-title": "Pobočka",
    "cart-delivery-undeliverableItemsCombination":
      "Kombinaci produktů nelze doručit. Objednej, prosím, zvlášť.",
    "cart-delivery-deliveryOptions": "Možnosti doručení",
    "cart-customerInfo-title": "Moje údaje",
    "cart-customerInfo-actionButtons-addBillingInfo": "Zadat fakturační údaje",
    "cart-customerInfo-fields-customerEmail-label": "E-mail",
    "cart-customerInfo-fields-customerEmail-placeholder": "petr@novak.cz",
    "cart-customerInfo-fields-customerEmail-helpText":
      "Tvůj e-mail potřebujeme, abychom Tě mohli informovat o stavu objednávky",
    "cart-customerInfo-fields-customerName-label": "Jméno a příjmení",
    "cart-customerInfo-fields-customerName-placeholder": "Petr Novák",
    "cart-customerInfo-fields-customerName-helpText": "",
    "cart-customerInfo-fields-customerPhone-label": "Telefon",
    "cart-customerInfo-fields-customerPhone-placeholder": "123 456 789",
    "cart-customerInfo-fields-customerPhone-helpText":
      "Tvůj telefon potřebujeme, abychom Tě mohli rychle kontaktovat, pokud se objeví nečekaná situace.",
    "cart-billingInfo-title": "Fakturace",
    "cart-billingInfo-actionButtons-fillManually": "Vyplnit ručně",
    "cart-billingInfo-actionButtons-companyAddress": "Na firmu",
    "cart-billingInfo-fields-billingAddress-label": "Adresa",
    "cart-billingInfo-fields-billingAddress-placeholder": "Hlavní 1, Praha",
    "cart-billingInfo-fields-billingAddress-helpText": "",
    "cart-billingInfo-fields-billingAddressStreet-label": "Ulice",
    "cart-billingInfo-fields-billingAddressStreet-placeholder": "Hlavní 1, Praha",
    "cart-billingInfo-fields-billingAddressStreet-helpText": "",
    "cart-billingInfo-fields-billingAddressCity-label": "Město",
    "cart-billingInfo-fields-billingAddressCity-placeholder": "Praha",
    "cart-billingInfo-fields-billingAddressCity-helpText": "",
    "cart-billingInfo-fields-billingAddressPostal-label": "PSČ",
    "cart-billingInfo-fields-billingAddressPostal-placeholder": "110 00",
    "cart-billingInfo-fields-billingAddressPostal-helpText": "",
    "cart-billingInfo-fields-billingAddressCompanyICO-label": "IČO",
    "cart-billingInfo-fields-billingAddressCompanyICO-placeholder": "123 45 678",
    "cart-billingInfo-fields-billingAddressCompanyICO-helpText": "",
    "cart-billingInfo-fields-billingAddressCompanyName-label": "Firma",
    "cart-billingInfo-fields-billingAddressCompanyName-placeholder": "Firma s.r.o.",
    "cart-billingInfo-fields-billingAddressCompanyName-helpText": "",
    "cart-billingInfo-fields-invoiceNote-label": "Poznámka na fakturu",
    "cart-billingInfo-fields-invoiceNote-placeholder": "Dárek pro šéfovou",
    "cart-billingInfo-fields-invoiceNote-helpText": "",
    "cart-deliveryInfo-title": "Doručení",
    "cart-deliveryInfo-actionButtons-fillManually": "Vyplnit ručně",
    "cart-deliveryInfo-actionButtons-companyAddress": "Doručit na firmu",
    "cart-deliveryInfo-actionButtons-otherBillingInfo": "Jiné fakturační údaje",
    "cart-deliveryInfo-actionButtons-addBillingInfo": "Přidat fakturační údaje",
    "cart-deliveryInfo-recipientSameAsCustomerOptions-true": "pro mě",
    "cart-deliveryInfo-recipientSameAsCustomerOptions-false": "jako dárek",
    "cart-deliveryInfo-fields-recipientName-label": "Jméno a příjmení",
    "cart-deliveryInfo-fields-recipientName-placeholder": "Petr Novák",
    "cart-deliveryInfo-fields-recipientName-helpText": "",
    "cart-deliveryInfo-fields-recipientPhone-label": "Telefon",
    "cart-deliveryInfo-fields-recipientPhone-placeholder": "123 456 789",
    "cart-deliveryInfo-fields-recipientPhone-helpText":
      "Telefon příjemce potřebujeme, aby jej kurýr mohl kontaktovat.",
    "cart-deliveryInfo-fields-deliveryAddress-label": "Adresa",
    "cart-deliveryInfo-fields-deliveryAddress-placeholder": "Hlavní 1, Praha",
    "cart-deliveryInfo-fields-deliveryAddress-helpText": "",
    "cart-deliveryInfo-fields-deliveryAddressStreet-label": "Ulice",
    "cart-deliveryInfo-fields-deliveryAddressStreet-placeholder": "Hlavní 1, Praha",
    "cart-deliveryInfo-fields-deliveryAddressStreet-helpText": "",
    "cart-deliveryInfo-fields-deliveryAddressCity-label": "Město",
    "cart-deliveryInfo-fields-deliveryAddressCity-placeholder": "Praha",
    "cart-deliveryInfo-fields-deliveryAddressCity-helpText": "",
    "cart-deliveryInfo-fields-deliveryAddressPostal-label": "PSČ",
    "cart-deliveryInfo-fields-deliveryAddressPostal-placeholder": "110 00",
    "cart-deliveryInfo-fields-deliveryAddressPostal-helpText": "",
    "cart-deliveryInfo-fields-deliveryAddressCompanyICO-label": "IČO",
    "cart-deliveryInfo-fields-deliveryAddressCompanyICO-placeholder": "123 45 678",
    "cart-deliveryInfo-fields-deliveryAddressCompanyICO-helpText": "",
    "cart-deliveryInfo-fields-deliveryAddressCompanyName-label": "Firma",
    "cart-deliveryInfo-fields-deliveryAddressCompanyName-placeholder": "Firma s.r.o.",
    "cart-deliveryInfo-fields-deliveryAddressCompanyName-helpText": "",
    "cart-deliveryInfo-fields-deliveryNote-label": "Poznámka pro kurýra",
    "cart-deliveryInfo-fields-deliveryNote-placeholder": "První patro",
    "cart-deliveryInfo-fields-deliveryNote-helpText": "",
    "cart-deliveryInfo-fields-recipientNote-label": "Vzkaz pro příjemce",
    "cart-deliveryInfo-fields-recipientNote-placeholder": "Užij si dárek!",
    "cart-deliveryInfo-fields-recipientNote-helpText": "",
    "cart-deliveryInfo-fields-recipientInQuarantine-labelTrue": "Bezkontaktní doručení",
    "cart-deliverySlots-noMoreDaysAvailable": "další dny zatím<br>nemáme 😔",
    "cart-deliverySlots-noMoreSlotsAvailable": "Bohužel nemáme<br>žádné sloty 😔",
    "cart-note-title": "Poznámka",
    "cart-note-insert": "Přidat poznámku",
    "cart-note-fields-note-label": "Ještě něco na srdci?",
    "cart-note-fields-note-placeholder": "Kámen!",
    "cart-note-fields-note-helpText":
      "Budeme se snažit splnit modré z nebe! Ale taky jsme jen lidi, žejo 😜",
    "cart-payment-title": "Platba",
    "cart-stripeWallet-otherMethod": "Jiný způsob",
    "cart-orderButton-terms-pre": "Platbou souhlasím s",
    "cart-orderButton-terms-link": "obchodními podmínkami",
    "cart-confirmation-orderNumber-heading": "objednávka",
    "cart-confirmation-email-heading": "potvrzení",
    "cart-confirmation-merchantNote": "Těšíme se na příště!",
    "cart-confirmation-continueShoppingBtn": "ještě něco? 😜",

    // confirmation texts - these are configured in delivery methods
    "cart-confirmation-method-recipientSameAsCustomer-title": "Děkujeme",
    "cart-confirmation-method-recipientSameAsCustomer-paragraph": "Tvá objednávka se už vyřizuje.",
    "cart-confirmation-method-recipientNotSameAsCustomer-title": "Děkujeme",
    "cart-confirmation-method-recipientNotSameAsCustomer-paragraph":
      "Tvá objednávka se už vyřizuje a brzy ji odešleme příjemci.",

    // labels for override form
    "override-section--postfix-label": "popisek",
    "override-section--postfix-placeholder": "zástupný text",
    "override-section--postfix-helpText": "nápověda",
    "override-section-cart-main": "hlavní",
    "override-section-cart-main-key-cart-main-title": "nadpis košíku",
    "override-section-cart-header": "hlavička",
    "override-section-cart-header-key-cart-header-backToShop": "tlačítko na zavření košíku",
    "override-section-cart-itemList": "položky",
    "override-section-cart-itemList-key-cart-itemList-empty": "prázdný košík",
    "override-section-cart-promoCode": "promo kód",
    "override-section-cart-promoCode-key-cart-promoCode-title": "nadpis promo kódu",
    "override-section-cart-promoCode-key-cart-promoCode-field-promoCode": "promo kód",
    "override-section-cart-delivery": "doručení",
    "override-section-cart-delivery-key-cart-delivery-title": "nadpis doručení",
    "override-section-cart-delivery-key-cart-delivery-branch-title": "nadpis pobočky",
    "override-section-cart-delivery-key-cart-delivery-undeliverableItemsCombination":
      "text nedoručitelné kombinace",
    "override-section-cart-delivery-key-cart-delivery-deliveryOptions": "nadpis možností doručení",
    "override-section-cart-customerInfo": "zákazník",
    "override-section-cart-customerInfo-key-cart-customerInfo-title": "nadpis zákazníka",
    "override-section-cart-customerInfo-key-cart-customerInfo-actionButtons-addBillingInfo":
      "tlačítko přidat fakturační údaje",
    "override-section-cart-customerInfo-key-cart-customerInfo-fields-customerEmail": "e-mail",
    "override-section-cart-customerInfo-key-cart-customerInfo-fields-customerName": "jméno",
    "override-section-cart-customerInfo-key-cart-customerInfo-fields-customerPhone": "telefon",
    "override-section-cart-billingInfo": "fakturační údaje",
    "override-section-cart-billingInfo-key-cart-billingInfo-title": "nadpis fakturačních údajů",
    "override-section-cart-billingInfo-key-cart-billingInfo-actionButtons-fillManually":
      "tlačítko vyplnit ručně",
    "override-section-cart-billingInfo-key-cart-billingInfo-actionButtons-companyAddress":
      "tlačítko firemní adresa",
    "override-section-cart-billingInfo-key-cart-billingInfo-fields-billingAddress": "adresa",
    "override-section-cart-billingInfo-key-cart-billingInfo-fields-billingAddressStreet": "ulice",
    "override-section-cart-billingInfo-key-cart-billingInfo-fields-billingAddressCity": "město",
    "override-section-cart-billingInfo-key-cart-billingInfo-fields-billingAddressPostal": "PSČ",
    "override-section-cart-billingInfo-key-cart-billingInfo-fields-billingAddressCompanyICO": "IČO",
    "override-section-cart-billingInfo-key-cart-billingInfo-fields-billingAddressCompanyName":
      "Firma",
    "override-section-cart-billingInfo-key-cart-billingInfo-fields-invoiceNote":
      "Poznámka na fakturu",
    "override-section-cart-deliveryInfo": "doručovací údaje",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-title": "nadpis doručovacích údajů",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-actionButtons-fillManually":
      "tlačítko vyplnit ručně",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-actionButtons-companyAddress":
      "tlačítko firemní adresa",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-actionButtons-otherBillingInfo":
      "tlačítko ostatní údaje",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-actionButtons-addBillingInfo":
      "tlačítko přidat fakturační údaje",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-recipientSameAsCustomerOptions-true":
      "příjemce stejný jako objenávající",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-recipientSameAsCustomerOptions-false":
      "příjemce jiný než objednávající",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-recipientName": "jméno",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-recipientPhone": "telefon",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-deliveryAddress": "adresa",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-deliveryAddressStreet":
      "ulice",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-deliveryAddressCity": "město",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-deliveryAddressPostal": "PSČ",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-deliveryAddressCompanyICO":
      "IČO",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-deliveryAddressCompanyName":
      "Firma",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-deliveryNote":
      "Poznámka k doručení",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-recipientNote":
      "Poznámka pro příjemce",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-recipientInQuarantine-labelTrue":
      "Příjemce v karanténě",
    "override-section-cart-deliverySlots": "doručovací sloty",
    "override-section-cart-deliverySlots-key-cart-deliverySlots-noMoreDaysAvailable":
      "nenaplánované dny",
    "override-section-cart-deliverySlots-key-cart-deliverySlots-noMoreSlotsAvailable":
      "nejsou volné sloty",
    "override-section-cart-note": "poznámka",
    "override-section-cart-note-key-cart-note-title": "nadpis poznámky",
    "override-section-cart-note-key-cart-note-fields-note": "poznámka",
    "override-section-cart-payment": "platba",
    "override-section-cart-payment-key-cart-payment-title": "nadpis platby",
    "override-section-cart-orderButton": "objednání",
    "override-section-cart-orderButton-key-cart-orderButton-terms-pre": "podmínky - začátek věty",
    "override-section-cart-orderButton-key-cart-orderButton-terms-link": "podmínky - odkaz",
    "override-section-cart-confirmation": "potvrzení",
    "override-section-cart-confirmation-key-cart-confirmation-orderNumber-heading":
      "nadpis číslo objednávky",
    "override-section-cart-confirmation-key-cart-confirmation-email-heading": "nadpis e-mail",
    "override-section-cart-confirmation-key-cart-confirmation-merchantNote": "vzkaz obchodníka",
    "override-section-cart-confirmation-key-cart-confirmation-continueShoppingBtn":
      "tlačítko pokračovat v nákupu",

    "product-field-title": "Název",
    "product-field-description": "Popis",
    "product-field-google-product-category": "Product Category ID",
    "product-tags": "Štítky",
    "product-sku": "SKU",
    "product-options": "Možnosti",
    "product-variants": "Varianta",
    "product-dynamic-sections": "Dynamické sekce",
    "product-customer-form": "Zákaznická pole",
    "product-kind": "Druh",
    "product-sub-kind": "kategorie",
    "product-images": "Fotografie",
    "product-gift-card-images": "Fotografie na dárkové karty",
    "product-gift-card-images-description":
      "Formát JPEG; Zachovejte poměr stran obrázku přibližně 1:2. Doporučujeme min. rozlišení 1 170 x 2 480 px; jiné rozměry budou při generování PDF automaticky vycentrovány a oříznuty. Výsledná velikost po tisku má formát DL (1/3 A4 = 99 x 210 mm).",
    "product-gift-card-settings": "Nastavení dárkových karet",
    "product-booking-settings": "Nastavení rezervací",
    "product-quantity": "Sklad & viditelnost",
    "product-quantity-stock": "Sklad",
    "product-quantity-available": "dostupné",
    "product-quantity-blocked": "blokované",
    "product-quantity-reserved": "rezervované",
    "product-quantity-when-sold-out": "po vyprodání",
    "product-shipping": "Logistika",
    "product-shipping-dimensions": "Rozměry",
    "product-shipping-available-deliveries": "Dostupná doprava",
    "product-channels": "Prodejní cesty",
    "item-labels": "atributy",
    "item-labels-adding-name": "název",
    "item-labels-group": "skupina atributů",
    "item-labels-add": "přidat atribut",
    "item-vod-videos": "videa na vyžádání",
    "item-vod-free-preview": "náhled zdarma",
    "item-vod-seconds": "sekund",
    "item-vod-or": "nebo",
    "item-vod-separate-video": "přidat separátní video",
    "item-vod-remove": "odstranit",
    "item-vod-confirm": "potvrdit",
    "item-vod-processing": "probíhá konverze",
    "item-vod-notified-via-email":
      "Až bude video připraveno k prodeji, dostaneš notifikaci e-mailem.",
    "system-settings": "Systémová nastavení",
    "other-settings": "Ostatní",
    "channel-online": "Online",
    "product-files": "Soubory",
    "add-a-new": "Přidat nový:",
    "button-add-variant": "Přidat variantu",
    "button-add-product": "Produkt",
    "button-add-option": "+ Přidat možnost",
    "button-add-attribute": "+ Přidat atribut",
    "product-field-type": "Typ",
    "product-field-name": "Název",
    "question-product-opt-delete": "Opravdu si přejete smazat tuto možnost?",
    "question-product-product-delete": "Opravdu si přejete smazat tento produkt?",
    "question-product-product-variants-delete":
      "Opravdu si přejete smazat tento produkt a jeho varianty?",
    "product-enable-stock-track": "Sledování skladu",
    "product-min-order": "Minimální množství objednávky:",
    "product-when-sold-out": "Po vyprodání",
    "product-on-sold-hide": "skrýt",
    "product-on-sold-disable": "zakázat",
    "product-on-sold-preorder": "předprodej",
    "product-show-as-preorder": "předprodej",
    "product-show-as": "Viditelnost",
    "product-show-as-hide": "skrytý",
    "product-show-as-unavailable": "nedostupný",
    "product-show-as-available": "dostupný",
    "product-show-as-auto": "podle skladu",
    "product-show-stock-counts": "Zobrazovat počet na skladu",
    "product-pricing": "Cena",
    "product-enable-reservation": "Povolit reservování",
    "product-reservation-timeout": "Doba rezervování zboží k objednání",
    "commerce-pricing-base": "Základ",
    "commerce-pricing-tax": "Daň",
    "commerce-pricing-final": "Celkem",
    "commerce-pricing-purchased": "Pořizovací cena",
    "commerce-pricing-commission": "Provize",
    "commerce-pricing-profit": "Profit",
    "commerce-package-dimensions-length": "d",
    "commerce-package-dimensions-width": "š",
    "commerce-package-dimensions-height": "v",
    "shipping-weight": "Váha [kg]",
    "shipping-dimensions": "Rozměry [cm]",
    "question-product-file-attr-delete": "Opravdu si přejete smazat tento atribut?",
    "question-product-file-delete": "Opravdu si přejete smazat tento soubor?",
    "commerce-flow-delete-error": "Nelze smazat stav, protože je použitý v: [%0]",

    "signup-email": "Vaše emailová adresa",
    "signup-site-domain": "Jak nazveme vaši doménu?",
    "signup-done": "... zkontrolujte svoji e-mailovou schránku.",

    "products-prepared": "Připraveno -> Odeslat",

    "button-cancel": "Zrušit",
    "button-confirm": "Potvrdit",
    "button-remove": "Odebrat",
    "button-save-draft": "Uložit náčrt",
    "button-publish": "Publikovat",
    "button-publish-all": "Publikovat vše",
    "button-save": "Uložit",
    "button-add": "Přidat",
    "button-add-file": "Přidat soubor",
    "button-change-file": "Nahradit soubor",
    "button-add-font": "Přidat font",
    "button-delete": "Smazat",
    "button-all": "Vše",
    "button-signup": "Registrovat",

    // "order-incomming-new" : "Nová objednávka! [%0]",
    "order-incomming-new": "Nová objednávka!",
    "orders-customer": "Zákazník",
    "orders-products": "Obsah",
    "orders-shipping": "Doprava",
    "order-payment-not-paid": "Zatím neuhrazeno",
    "order-payment-paid": "Zaplaceno:",
    "order-customer-note": "Poznámka zákazníka",
    "order-customer-notify": "Informovat zákazníka",
    "order-note-add": "Přidat poznámku",
    "order-pay-products": "Produkty",
    "order-pay-delivery": "Doručení",
    "order-pay-payment": "Platba",
    "order-pay-discount": "Sleva",
    "order-pay-total": "Zákazník zaplatí",
    "order-pay-method-card-online": "Kartou online",
    "order-pay-method-card-site": "Kartou v obchodě",
    "order-pay-method-card-deliv": "Kartou při převzetí",
    "order-pay-method-cash-site": "V hotovosti v obchodě",
    "order-pay-method-cash-deliv": "V hotovosti při převzetí (dobírka)",
    "order-pay-method-bank-wire": "Bankovním převodem",
    "order-pay-method-paypal": "Paypal",
    "order-shipping-method-branch": "Vyzvednutí na pobočce",
    "order-shipping-method-branch-pob1-onspot": "Pobočka",
    "order-shipping-method-messanger": "Kurýr",
    "order-shipping-method-ppl": "PPL",
    "order-shipping-method-ups": "UPS",
    "order-shipping-method-zasilkovna": "Zásilkovna",
    "order-shipping-method-cpost": "Česká Pošta",
    "order-shipping-method-cpost-ob": "Česká Pošta - Obchodní balík",
    "order-shipping-method-custom": "Vlastní",
    "order-shipping-method-popup": "Pop-up",
    "order-shipping-method-popup-praktika1": "Pop-up Praktika Letná",
    "order-shipping-method-no-delivery": "Bez doručení",
    "order-details-title": "Detaily objednávky",
    "order-details-created": "vytvořena",
    "order-details-paid": "zaplacena",
    "order-details-due": "splatná",
    "order-details-tax": "DUZP",
    "order-details-variable-symbol": "variabilní symbol",

    oa_state_unpaid: "Nezaplaceno",
    oa_state_paid: "Zaplaceno",
    oa_state_preparing: "Příprava produktu",
    oa_state_printing: "Tisk štítků",
    oa_state_packing: "Balení",
    oa_state_dispatching: "K Odeslání",
    oa_state_sent: "Odesláno",
    oa_state_pickup: "K vyzvednutí",
    oa_state_refunding: "Náhrady",
    oa_state_cancelled: "Zrušeno",
    oa_state_archived: "Archivováno",
    oa_go_paid: "Bylo zaplaceno",
    oa_go_prepare: "Připravit produkty",
    oa_go_print: "Vytisknout štítky",
    oa_go_pack: "Zabalit zboží",
    oa_go_cancel: "Zrušit",
    oa_go_dispatch: "Předat",
    oa_go_send: "Odeslat",
    oa_go_pickup: "Možné vyzvednout",
    oa_go_refund: "Vrátit platbu",
    oa_go_archive: "Archivovat",
    oa_go_open: "Otevřít",

    "user-action-user-looked": "Objednávka otevřena",
    "user-action-moving-state": "Změněn stav",
    "user-action-info-note-checked": "Označena poznámka zákazníka",
    "user-action-info-note-unchecked": "Odznačena poznámka zákazníka",
    "user-action-courier-note-checked": "Označena poznámka pro kurýra",
    "user-action-courier-note-unchecked": "Odznačena poznámka pro kurýra",
    "user-action-recipient-note-checked": "Označen vzkaz pro příjemce",
    "user-action-recipient-note-unchecked": "Odznačen vzkaz pro příjemce",
    "user-action-contactless-checked": "Označeno bezkontaktní doručení",
    "user-action-contactless-unchecked": "Odznačeno bezkontaktní doručení",
    "user-action-item-checked": "Označena položka",
    "user-action-item-unchecked": "Odznačena položka",
    "user-action-updated-private-note": "Upravena privátní poznámka",
    "user-action-deleted-private-note": "Smazána privátní poznámka",
    "user-action-invoice-downloaded": "Stažena faktura",
    "user-action-invoice-sent": "Faktura ručně odeslána zákazníkovi",
    "user-action-email-sent": "E-mail odeslán",
    "user-action-refundSlip-downloaded": "Stažen opravný doklad",
    "cart-created": "Vytvořen košík",
    "cart-item-added": "Přidán produkt",
    "cart-item-updated": "Upraven produkt",
    "cart-item-removed": "Odebrán produkt",
    "order-created": "Vytvořena objednávka",
    "stripe-payment-created": "Zahájená platba",
    "stripe-payment-requires-action": "Platba vyžaduje akci",
    "stripe-payment-succeeded": "Úspěšná platba",
    "stripe-payment-failed": "Neúspěšná platba",
    "resend-sent": "E-mail odeslán",
    "resend-delivery_delayed": "E-mail opožděn",
    "resend-bounced": "E-mail vrácen",
    "resend-delivered": "E-mail doručen",
    "resend-opened": "E-mail otevřen",
    "resend-clicked": "Otevřen odkaz v e-mailu",
    "resend-complained": "E-mail označen jako spam",
    "sendgrid-processed": "E-mail zpracován",
    "sendgrid-deferred": "E-mail odložen",
    "sendgrid-delivered": "E-mail doručen",
    "sendgrid-open": "E-mail otevřen",
    "sendgrid-click": "Otevřen odkaz v e-mailu",
    "sendgrid-bounce": "E-mail vrácen",
    "sendgrid-dropped": "E-mail vrácen",
    "sendgrid-blocked": "E-mail blokován",
    "sendgrid-spamreport": "E-mail nahlášen jako spam",
    "liftago-STOP_ON_BOARD": "Naloženo",
    "liftago-STOP_DELIVERED": "Doručeno",
    "liftago-STOP_UNDELIVERED": "Nedoručeno",
    "sendNotification-sent": "E-mail odeslán",
    "sendNotification-error": "E-mail neodeslán",
    "sendNotification-nonproduction":
      "Sendgrid webhooks are only processed in production environment",
    "dispatch-liftago-dispatched": "Jízda objednána",
    "dispatch-liftago-dispatch-error": "Chyba objednávky jízdy",
    "invoice-download": "stažení faktury zákazníkem",
    "digital-product-download": "stažení digitálního produktu zákazníkem",
    "giftCard-download-by-customer": "stažení dárkové karty zákazníkem",
    "giftCard-download-by-recipient": "stažení dárkové karty příjemcem",

    "stripe-error-card-expired": "Karta expirovala. Použijte jinou kartu.",
    "stripe-decline-card-expired": "Karta expirovala. Použijte jinou kartu.",
    "stripe-decline-auth-required": "Platba vyžaduje autorizaci. Zkuste znovu.",
    "stripe-decline-try-again": "Zkuste znovu nebo kontaktujte Vaši banku.",
    "stripe-decline-contact-bank": "Kontaktujte Vaši banku.",
    "stripe-decline-duplicate": "Duplicitní platba",
    "stripe-decline-incorrect-number": "Chybné číslo karty",
    "stripe-decline-incorrect-cvc": "Chybné CVC",
    "stripe-decline-incorrect-expiry": "Chybná expirace",
    "stripe-decline-insufficient-funds": "Zkontrolujte stav svého účtu.",
    "stripe-decline-test-card": "Nepoužívejte testovací kartu.",
    "stripe-decline-test-mode-live-card": "Ostrá karta použita v testovacím módu",

    "stripe-requires-action-3ds2": "Ověření 3D secure",

    "billing-address": "Fakturační adresa",
    "delivery-address": "Doručovací údaje",
    "order-courier-deliver-details": "Doručení",
    "order-courier-recipient-details": "Příjemce",
    "order-courier-dispatch": "Odeslání",

    "order-courier-ordered": "Kurýr objednán",
    "order-courier-dispatched": "Odesláno",

    "block-config-name": "Název bloku",
    "block-config-shared": "Sdílený",
    "block-config-region": "Region",
    "block-config-viewports": "Viewports",
    "block-config-tag": "Tag",

    "forms-field-id": "ID",
    "forms-field-type": "Typ pole",
    "target-window-same": "Stejné okno",
    "target-window-new": "Nové okno",

    "form-font-name": "Název fontu",
    "form-font-weight": "Font weight (CSS)",
    "form-font-url": "URL fontu",
    "form-font-source-file": "Soubor fontu",

    "page-create-new": "Nová stránka",
    "page-create-new-abort": "Přerušit přidávání",
    "page-create-new-info": "Nyní vyberte strnku nadřazenou nové",
    "page-new-name": "Nová stránka",
    "page-new-slug": "novastranka",
    "page-new-created": "Nová stránka byla vytvořena",
    "page-new-not-created": "Novou stránku se nepodařilo vytvořit! Více informací v konzili.",

    "shared-blocks-label": "Sdílené",
    "private-blocks-label": "Privátní",

    "settings-css-header": "Styly",
    "settings-scripts-header": "Scripty",
    "settings-config-header": "Nasvení stylů",
    "settings-fonts-header": "Fonty",

    "template-editor": "Šablony",
    "theme-label-fonts": "Fonty",
    "theme-label-scripts": "Soubory skriptů",

    "field-listing-source": "Zdroj dat",
    "field-listing-root-page": "Kořenová stránka",

    "question-publish-all": "Do you relly want to publish all?",
    "message-info-site-published": "Stránka byla publikována",
    "error-login-nonce-request":
      "Přihlášení se nezdařilo. Opakujte proces ještě jednou, a pokud to nepomůže, tak nás neváhejte kontaktovat.",
    "error-email-invlaid": "E-mail adresa není platná!",
    "error-email-not-found": "E-mail adresa nebyla nalezena!",
    "error-sitemName-already-used": "Tento název stránky je již použitý!",
    "error-email-already-used": "Tato e-mailová adresa je již použita!",
    "error-both-already-used": "Obě hodnoty jsou již použité!",
    "error-invlaid-values": "Formulář není řádně vyplněn!",

    // Profile
    "profile-change-password": "Změnit heslo",
    "profile-passkeys": "Klíče",
    "profile-notifications": "Notifikace",
    "profile-admin-lang": "Jazyk administrace",

    // View titles
    "view-title-apps": "aplikace",
    "view-title-sites": "weby",
    "view-title-site-settings": "nastavení webu",
    "view-title-site-settings-sections": "sekce",
    "view-title-site-settings-domains": "domény",
    "view-title-pages": "stránky",
    "view-title-page-settings": "nastavení stránky",
    "view-title-documents": "dokumenty",
    "view-title-documents-wizard": "průvodce",
    "view-title-documents-layouts": "rozložení",
    "view-title-documents-layout-edit": "úprava rozložení",
    "view-title-documents-templates": "šablony",
    "view-title-documents-wizard-option-simplest-title": "vybrat existující rozložení",
    "view-title-documents-wizard-option-simplest-description": "potřebuji samolepky na vytištěné poukazy nebo navrhnout PDF poukaz na základě existujícího rozložení",
    "view-title-documents-wizard-option-simple-title": "použít moje tisková data",
    "view-title-documents-wizard-option-simple-description": "mám profesionální tisková data s ořezovými značkami a chci na ně umístit kódy",
    "view-title-documents-wizard-option-advanced-title": "navrhnout od začátku",
    "view-title-documents-wizard-option-advanced-description": "chci vytvořit rozložení a šablonu ručně od začátku",
    "view-title-balances": "konta",
    "view-title-balances-detail": "konto",
    "view-title-balances-transact": "transakce konta",
    "view-title-identity-companies": "firmy",
    "view-title-identity-persons": "osoby",
    "view-title-booking": "rezervace",
    "view-title-booking-back": "zpět",
    "view-title-booking-reservations": "rezervace",
    "view-title-booking-slots": "sloty",
    "view-title-booking-services": "služby",
    "view-title-booking-resources": "zdroje",
    "view-title-commerce": "obchod",
    "view-title-commerce-carts": "košíky",
    "view-title-commerce-orders": "objednávky",
    "view-title-commerce-orders-items": "položky objednávek",
    "view-title-commerce-inventory": "produkty",
    "view-title-commerce-inventory-product": "produkt",
    "view-title-commerce-inventory-products": "produkty",
    "view-title-commerce-settings": "nastavení obchodu",
    "view-title-commerce-order-flow": "stavy objednávek",
    "view-title-commerce-entitlements": "nosiče", // nárok | médium
    "view-title-commerce-voucher-templates": "šablony poukazů",
    "view-title-commerce-promocodes": "promo kódy",
    "view-title-commerce-giftcards": "dárkové karty",
    "view-title-commerce-giftcard-detail": "dárková karta",
    "view-title-commerce-giftcard-validation": "validace dárkové karty",
    "view-title-commerce-delivery-planning": "doručovací sloty",
    "view-title-commerce-fee-reports": "poplatky",
    "view-title-billing": "vyúčtování",
    "view-title-billing-invoices": "faktury",
    "view-title-billing-balance": "konto",
    "view-title-billing-transactions": "transakce",
    "view-title-billing-meters": "měřiče",
    "view-title-profile": "můj profil",
    "view-title-profile-changepassword": "změna hesla",
    "view-title-profile-passkeys": "Klíče",
    "view-title-profile-notifications": "Notifikace",
    "view-title-commerce-promocode-detail": "detail kódu",
    "view-title-commerce-promocode-import": "import kódů",
    "view-title-commerce-settings-general": "základní",
    "view-title-commerce-settings-invoicing": "faktury",
    "view-title-commerce-settings-payment": "platby",
    "view-title-commerce-settings-delivery": "doručení",
    "view-title-commerce-settings-delivery-method": "metoda",
    "view-title-commerce-settings-cart": "košík",
    "view-title-commerce-settings-emails": "e-maily",
    "view-title-commerce-settings-channels": "kanály",
    "view-title-commerce-export": "export",
    "view-title-platform": "platforma",
    "view-title-platform-wizard": "průvodce",
    "view-title-platform-clients": "klienti",
    "view-title-platform-clients-detail": "klient",
    "view-title-platform-sites": "weby",
    "view-title-platform-sites-detail": "web",
    "view-title-platform-users": "uživatelé",
    "view-title-platform-users-detail": "uživatel",
    "view-title-platform-billing-balances": "billing konta",
    "view-title-platform-shops": "obchody",
    "view-title-platform-shops-detail": "obchod",
    "view-title-platform-events": "akce",
    "view-title-platform-events-detail": "akce",
    "view-title-platform-api-keys": "api klíče",
    "view-title-platform-api-scopes": "api oprávnění",
    "view-title-platform-entitlements-pass-projects": "ent. pass projekty",
    "view-title-platform-entitlements-pass-apple-pki": "ent. pass apple pki",
    "view-title-platform-system": "systém",
    "view-title-platform-orgs": "organizace",
    "view-title-tools": "nástroje",
    "view-title-tools-pos-emulator": "POS emulator",
    "view-title-tools-qr-generator": "QR generator",
    "view-title-tools-liftago-mock": "Liftago mock",
    "view-title-tools-qr-scanner": "QR skener",
    "tools-qr-scanner-collection-label": "sbírka",
    "tools-qr-scanner-collection-create": "nová",
    "tools-qr-scanner-collection-modal-title": "nová sbírka",
    "tools-qr-scanner-collection-name-label": "název",
    "tools-qr-scanner-collection-cancel": "zrušit",
    "tools-qr-scanner-collection-save": "vytvořit",
    "tools-qr-scanner-no-collection-hint": "vyberte sbírku pro automatické ukládání skenů",
    "tools-qr-scanner-save-success": "kód uložen",
    "tools-qr-scanner-save-error": "chyba při ukládání",
    "tools-qr-scanner-items-empty": "žádné skeny",

    "delivery-method-constraints-label": "Možnosti doručení",
    "delivery-method-constraints-min-dispatch-time": "Odeslání nejdříve za",
    "delivery-method-constraints-min-dispatch-time-since-order": "od objednání",
    "delivery-method-constraints-shipping-from": "Odeslání od",
    "delivery-method-constraints-shipping-to": "Odeslání do",

    "platform-billing-balances-col-value-status-active": "aktivní",
    "platform-billing-balances-col-value-status-suspended": "pozastaven",
    "platform-billing-balances-col-value-status-closed": "uzavřen",
    "platform-billing-balances-table-col-id": "ID",
    "platform-billing-balances-table-col-org": "organizace",
    "platform-billing-balances-table-col-status": "stav",
    "platform-billing-balances-table-col-available": "zůstatek",
    "platform-billing-balances-table-col-credit-limit": "kreditní limit",
    "platform-billing-balances-table-col-lifetime-credit": "Σ připsáno",
    "platform-billing-balances-table-col-lifetime-debit": "Σ odepsáno",
    "platform-billing-balances-table-col-currency": "měna",
    "platform-billing-balances-table-col-created-at": "vytvořen",
    "platform-billing-balances-table-col-updated-at": "aktualizován",
    "platform-billing-balances-button-transact-label": "transakce",

    "platform-billing-balance-transact-form-title": "Transakce",
    "platform-billing-balance-transact-form-type-debit": "odepsat",
    "platform-billing-balance-transact-form-type-credit": "připsat",
    "platform-billing-balance-transact-form-amount-label": "částka",
    "platform-billing-balance-transact-form-amount-placeholder": "1000",
    "platform-billing-balance-transact-form-actions-cancel-label": "zrušit",
    "platform-billing-balance-transact-form-actions-transact-debit-label": "odepsat",
    "platform-billing-balance-transact-form-actions-transact-credit-label": "připsat",
    "platform-billing-balance-transact-form-actions-transactConfirm-label": "potvrdit",
    "platform-billing-balance-transact-form-note-platform-label": "poznámka",
    "platform-billing-balance-transact-form-note-platform-placeholder": "vratka",
    "platform-billing-balance-transact-form-note-platform-caption": "interní",

    // documents wizard
    "documents-wizard-title": "Jak chcete vytvořit rozložení?",
    "documents-wizard-back": "zpět",
    "documents-wizard-select-layout": "vybrat rozložení",
    "documents-wizard-loading-layouts": "načítám rozložení...",
    "documents-wizard-no-layouts": "žádná rozložení k dispozici",
    "documents-wizard-vouchers": "Vouchery",
    "documents-wizard-stickers": "Samolepky",
    "documents-wizard-supported-cases": "Podporované případy:",
    "documents-wizard-supported-case-digital-online": "Digitální - Online nákup",
    "documents-wizard-supported-case-digital-manual": "Digitální - Ruční vydání",
    "documents-wizard-supported-case-print": "Tisk",
    "documents-wizard-none": "Žádné",

    // pdf layout editor
    "pdf-layout-editor-download-preview": "stáhnout náhled",
    "pdf-layout-editor-cancel": "zrušit",
    "pdf-layout-editor-save": "uložit",
    "pdf-layout-editor-output": "výstup",
    "pdf-layout-editor-output-print": "tisk",
    "pdf-layout-editor-output-digital": "digitální",
    "pdf-layout-editor-highlight-final-size": "zvýraznit finální velikost",
    "pdf-layout-editor-highlight-margin": "zvýraznit okraj",
    "pdf-layout-editor-highlight-bleed-box": "zvýraznit spadávku",
    "pdf-layout-editor-reset": "resetovat",
    "pdf-layout-editor-rendering": "vykresluji PDF...",
    "pdf-layout-editor-layout-type": "typ rozložení",
    "pdf-layout-editor-supported-cases": "podporované případy",
    "pdf-layout-editor-layout-validator": "validátor rozložení",
    "pdf-layout-editor-required": "povinné:",
    "pdf-layout-editor-recommended": "doporučené:",
    "pdf-layout-editor-all-requirements-met": "✓ všechny požadavky splněny",
    "pdf-layout-editor-qr-code-or-code": "QR kód nebo kód",
    "pdf-layout-editor-valid-to": "platnost do",
    "pdf-layout-editor-both-qr-and-code": "oba QR kód i kód",
    "pdf-layout-editor-units": "jednotky",
    "pdf-layout-editor-units-caption": "pouze pro zobrazení",
    "pdf-layout-editor-units-millimeters": "milimetry",
    "pdf-layout-editor-units-points": "body",
    "pdf-layout-editor-type-voucher": "voucher",
    "pdf-layout-editor-type-sticker": "samolepka",
    "pdf-layout-editor-type-card": "karta",
    "pdf-layout-editor-mode-inherited": "zděděné",
    "pdf-layout-editor-mode-manual": "ruční",

    // entitlements add form
    "entitlements-add-form-title": "vytvořit nosič",
    "entitlements-add-form-type": "typ",
    "entitlements-add-form-count": "počet",
    "entitlements-add-form-code": "kód",
    "entitlements-add-form-codes": "kódy",
    "entitlements-add-form-balance": "konto",
    "entitlements-add-form-enter-code": "zadat kód",
    "entitlements-add-form-one-code-per-line": "jeden kód na řádek",
    "entitlements-add-form-enter-codes": "zadat kódy, jeden na řádek",
    "entitlements-add-form-attach-to-existing-balance": "připojit k existujícímu kontu",
    "entitlements-add-form-balance-mode-none": "žádné",
    "entitlements-add-form-balance-mode-link": "připojit k existujícímu",
    "entitlements-add-form-balance-mode-create": "vytvořit nové",
    "entitlements-add-form-code-mode-auto": "automaticky",
    "entitlements-add-form-code-mode-auto-sublabel": "kódy jsou generovány",
    "entitlements-add-form-code-mode-manual": "ručně",
    "entitlements-add-form-code-mode-manual-sublabel": "zadat kódy",
    "entitlements-add-form-type-voucher-sublabel": "digitální / tištěný PDF nebo samolepka",
    "entitlements-add-form-type-pass-sublabel": "Lístek do Apple / Google Peněženky",
    "entitlements-add-form-type-card-sublabel": "fyzická karta",
    "entitlements-add-form-template": "šablona",
    "entitlements-add-form-generate-print-data": "generovat tisková data",
    "entitlements-add-form-print-data-name": "název",
    "entitlements-add-form-print-data-name-default": "Hromadná tisková data - %0 %1",
    "entitlements-add-form-print-data-name-default-item": "položka",
    "entitlements-add-form-print-data-name-default-items": "položek",
    "entitlements-add-form-print-data-format": "formát tiskových dat",
    "entitlements-add-form-print-data-format-single-pdf": "více stránek v jednom PDF",
    "entitlements-add-form-print-data-format-zip-pdfs": "PDF na stránku v ZIP",
    "entitlements-add-form-print-data-warning": "Vygenerované soubory obsahují citlivé kódy, se kterými musí být zacházeno opatrně. Ujistěte se, že spolupracujete s důvěryhodným tiskovým poskytovatelem.",
    "entitlements-add-form-print-data-accept-risk": "akceptuji riziko",
    "entitlements-add-form-link-person": "Připojit osobu",
    "entitlements-add-form-person": "Osoba",
    "entitlements-add-form-create": "vytvořit",
    "entitlements-add-form-confirm": "potvrdit",

    // document template add form
    "document-template-add-form-loading": "načítám...",
    "document-template-add-form-name": "název",
    "document-template-add-form-name-placeholder": "název šablony",
    "document-template-add-form-layout": "rozložení",
    "document-template-add-form-supported-locales": "podporované jazyky",
    "document-template-add-form-universal-caption": "pokud není vybrán žádný, šablona bude uložena jako 'universal' (nelokalizovaná)",
    "document-template-add-form-objects": "objekty",
    "document-template-add-form-select-layout-preview": "vyberte rozložení pro zobrazení náhledu",

    // document layout form
    "document-layout-form-title": "rozložení dokumentu",
    "document-layout-form-name": "název",
    "document-layout-form-mode": "režim",
    "document-layout-form-base-pdf": "základní PDF",
    "document-layout-form-base-pdf-caption": "nahrajte svůj PDF soubor s tiskovými daty",
    "document-layout-form-final-size": "finální velikost",
    "document-layout-form-trim-area-warning-title": "⚠️ ořezová oblast nebyla detekována",
    "document-layout-form-trim-area-warning-text": "tento PDF soubor nemusí být ideální pro tisk. pokud si nejste jisti, kontaktujte podporu.",
    "document-layout-form-page": "stránka",
    "document-layout-form-size": "velikost",
    "document-layout-form-orientation": "orientace",
    "document-layout-form-width": "šířka",
    "document-layout-form-height": "výška",
    "document-layout-form-bleed": "spadávka",
    "document-layout-form-margin": "okraj",
    "document-layout-form-top": "nahoře",
    "document-layout-form-right": "vpravo",
    "document-layout-form-bottom": "dole",
    "document-layout-form-left": "vlevo",
    "document-layout-form-show-trim-marks": "zobrazit ořezové značky",
    "document-layout-form-system": "systém",
    "document-layout-form-system-caption": "dostupné pro všechny obchodníky",
    "document-layout-form-preset-custom": "vlastní",
    "document-layout-form-preset-a4": "A4",
    "document-layout-form-preset-a5": "A5",
    "document-layout-form-preset-credit-card": "kreditní karta",
    "document-layout-form-orientation-portrait": "na výšku",
    "document-layout-form-orientation-landscape": "na šířku",

    // document layout objects form
    "document-layout-objects-form-title": "objekty",
    "document-layout-objects-form-move-up": "posunout nahoru",
    "document-layout-objects-form-move-down": "posunout dolů",
    "document-layout-objects-form-remove": "odstranit",
    "document-layout-objects-form-object": "objekt",
    "document-layout-objects-form-select-object-type": "vybrat typ objektu",
    "document-layout-objects-form-close": "zavřít",
    "document-layout-objects-form-type-qr": "QR kód",
    "document-layout-objects-form-type-qr-description": "generovat QR kódy",
    "document-layout-objects-form-type-text": "text",
    "document-layout-objects-form-type-text-description": "přidat textový obsah",
    "document-layout-objects-form-type-rectangle": "obdélník",
    "document-layout-objects-form-type-rectangle-description": "nakreslit obdélníky a rámečky",
    "document-layout-objects-form-type-circle": "kruh",
    "document-layout-objects-form-type-circle-description": "nakreslit kruhy",
    "document-layout-objects-form-type-image": "obrázek",
    "document-layout-objects-form-type-image-description": "vložit obrázky",
    "document-layout-objects-form-type-pdf": "PDF",
    "document-layout-objects-form-type-pdf-description": "vložit stránky PDF",
    "document-layout-objects-form-type-svg": "SVG",
    "document-layout-objects-form-type-svg-description": "přidat SVG grafiku",
    "document-layout-objects-form-type-paragraph": "odstavec",
    "document-layout-objects-form-type-paragraph-description": "přidat víceřádkový text",
    "document-layout-objects-form-type-text-circular": "kruhový text",
    "document-layout-objects-form-type-text-circular-description": "text podél kruhové cesty",
    "document-layout-objects-form-reference-point-top-left": "nahoře vlevo",
    "document-layout-objects-form-reference-point-top-center": "nahoře uprostřed",
    "document-layout-objects-form-reference-point-top-right": "nahoře vpravo",
    "document-layout-objects-form-reference-point-middle-left": "uprostřed vlevo",
    "document-layout-objects-form-reference-point-center": "uprostřed",
    "document-layout-objects-form-reference-point-middle-right": "uprostřed vpravo",
    "document-layout-objects-form-reference-point-bottom-left": "dole vlevo",
    "document-layout-objects-form-reference-point-bottom-center": "dole uprostřed",
    "document-layout-objects-form-reference-point-bottom-right": "dole vpravo",

    // object fields - common
    "object-field-name": "název",
    "object-field-position": "pozice",
    "object-field-x": "X",
    "object-field-y": "Y",
    "object-field-reference-point": "referenční bod",
    "object-field-width": "šířka",
    "object-field-height": "výška",
    "object-field-color": "barva",
    "object-field-color-cmyk": "barva (CMYK)",
    "object-field-border-color": "barva rámečku",
    "object-field-border-width": "šířka rámečku",
    "object-field-opacity": "průhlednost",
    "object-field-background": "pozadí",
    "object-field-padding-top": "odskok nahoře",
    "object-field-padding-right": "odskok vpravo",
    "object-field-padding-bottom": "odskok dole",
    "object-field-padding-left": "odskok vlevo",
    "object-field-font-size": "velikost písma",
    "object-field-font-family": "rodina písma",
    "object-field-font-weight": "tloušťka písma",
    "object-field-position-top-left": "nahoře vlevo",
    "object-field-position-top-center": "nahoře uprostřed",
    "object-field-position-top-right": "nahoře vpravo",
    "object-field-position-middle-left": "uprostřed vlevo",
    "object-field-position-middle-center": "uprostřed",
    "object-field-position-middle-right": "uprostřed vpravo",
    "object-field-position-bottom-left": "dole vlevo",
    "object-field-position-bottom-center": "dole uprostřed",
    "object-field-position-bottom-right": "dole vpravo",
    "object-field-position-custom": "vlastní",

    // object fields - qr
    "object-field-qr-value-type": "typ hodnoty",
    "object-field-qr-value-type-custom": "vlastní",
    "object-field-qr-value-type-code-url": "kód URL",
    "object-field-qr-value": "hodnota",
    "object-field-qr-size": "velikost",
    "object-field-qr-size-caption": "min. 35 pt ~ 12.3 mm",
    "object-field-qr-label": "štítek",
    "object-field-qr-label-value-type": "typ hodnoty",
    "object-field-qr-label-value-type-custom": "vlastní",
    "object-field-qr-label-value-type-code": "kód",
    "object-field-qr-label-value": "hodnota štítku",
    "object-field-qr-label-position": "pozice štítku",
    "object-field-qr-label-position-top": "nahoře",
    "object-field-qr-label-position-left": "vlevo",
    "object-field-qr-label-position-bottom": "dole",
    "object-field-qr-label-position-right": "vpravo",
    "object-field-qr-label-vertical-align": "vertikální zarovnání",
    "object-field-qr-label-vertical-align-top": "nahoře",
    "object-field-qr-label-vertical-align-middle": "uprostřed",
    "object-field-qr-label-vertical-align-bottom": "dole",
    "object-field-qr-label-font-size-mode-fit-width": "přizpůsobit šířce",
    "object-field-qr-label-font-size-mode-custom": "vlastní",
    "object-field-qr-label-align": "zarovnání štítku",
    "object-field-qr-label-align-left": "vlevo",
    "object-field-qr-label-align-center": "uprostřed",
    "object-field-qr-label-align-right": "vpravo",
    "object-field-qr-label-gap": "mezera",
    "object-field-qr-label-gap-caption": "mezera mezi QR kódem a štítkem",
    "object-field-qr-foreground-color": "barva QR kódu",
    "object-field-qr-background-color": "barva pozadí",

    // object fields - text
    "object-field-text-value-type": "typ hodnoty",
    "object-field-text-value-type-custom": "vlastní",
    "object-field-text-value-type-code": "kód",
    "object-field-text-value-type-valid-to": "platnost do",
    "object-field-text-value-type-valid-from": "platnost od",
    "object-field-text-value-type-order-id": "ID objednávky",
    "object-field-text-value-type-order-number": "číslo objednávky",
    "object-field-text-value-type-product-name": "název produktu",
    "object-field-text-value-type-face-value": "nominální hodnota",
    "object-field-text-text": "text",

    // object fields - rectangle
    // (uses common fields)

    // object fields - circle
    "object-field-circle-diameter": "průměr",

    // object fields - image
    "object-field-image-image": "obrázek",
    "object-field-image-image-fit": "přizpůsobení obrázku",
    "object-field-image-image-fit-fill": "vyplnit (krytí)",
    "object-field-image-image-fit-fit": "přizpůsobit (obsahovat)",
    "object-field-image-image-fit-stretch": "roztáhnout (zkreslit)",
    "object-field-image-image-position": "pozice obrázku",
    "object-field-image-image-position-top-left": "nahoře vlevo",
    "object-field-image-image-position-top-center": "nahoře uprostřed",
    "object-field-image-image-position-top-right": "nahoře vpravo",
    "object-field-image-image-position-middle-left": "uprostřed vlevo",
    "object-field-image-image-position-middle-center": "uprostřed",
    "object-field-image-image-position-middle-right": "uprostřed vpravo",
    "object-field-image-image-position-bottom-left": "dole vlevo",
    "object-field-image-image-position-bottom-center": "dole uprostřed",
    "object-field-image-image-position-bottom-right": "dole vpravo",
    "object-field-image-image-position-center": "uprostřed",
    "object-field-image-image-position-custom": "vlastní",
    "object-field-image-x-percent": "X (%)",
    "object-field-image-y-percent": "Y (%)",

    // object fields - pdf
    "object-field-pdf-pdf": "PDF",

    // object fields - svg
    "object-field-svg-svg": "SVG",

    // object fields - paragraph
    "object-field-paragraph-text": "text",
    "object-field-paragraph-text-placeholder": "zadat text...",
    "object-field-paragraph-align": "zarovnání",
    "object-field-paragraph-align-left": "vlevo",
    "object-field-paragraph-align-center": "uprostřed",
    "object-field-paragraph-align-right": "vpravo",
    "object-field-paragraph-align-justify": "do bloku",
    "object-field-paragraph-leading": "řádkování",
    "object-field-paragraph-space-before": "mezera před",
    "object-field-paragraph-space-after": "mezera po",
    "object-field-paragraph-baseline-mode": "režim základní linie",

    // object fields - text circular
    "object-field-text-circular-value-type": "typ hodnoty",
    "object-field-text-circular-value-type-custom": "vlastní",
    "object-field-text-circular-value-type-code": "kód",
    "object-field-text-circular-text": "text",
    "object-field-text-circular-radius": "poloměr",
    "object-field-text-circular-start-angle": "počáteční úhel (stupně)",
    "object-field-text-circular-outside": "venku",
    "object-field-text-circular-baseline-mode": "režim základní linie",

    // documents generated view
    "view-title-documents-generated": "vygenerované",
    "documents-generated-table-col-name": "název",
    "documents-generated-table-col-template": "šablona",
    "documents-generated-table-col-layout": "rozložení",
    "documents-generated-table-col-total-documents": "celkem dokumentů",
    "documents-generated-table-col-output-format": "formát výstupu",
    "documents-generated-table-col-status": "stav",
    "documents-generated-table-col-created": "vytvořeno",
    "documents-generated-table-col-actions": "akce",
    "documents-generated-download": "stáhnout",
    "documents-generated-regenerate": "vygenerovat znovu",
    "documents-generated-selected": "vybrané",
    "documents-generated-output-format-zip": "ZIP (PDF na stránku)",
    "documents-generated-output-format-single": "jednotlivé PDF",
    "documents-generated-error-loading": "chyba načítání generování dokumentů",
    "documents-generated-download-unavailable": "stáhnutí není k dispozici",
    "documents-generated-download-unavailable-no-url": "není k dispozici URL pro stažení tohoto dokumentu",
    "documents-generated-download-unavailable-no-documents": "nenalezeny žádné dokumenty pro toto generování",
    "documents-generated-error-downloading": "chyba stahování dokumentu",
    "documents-generated-download-failed": "stáhnutí selhalo",
    "documents-generated-download-failed-message": "nepodařilo se stáhnout soubor",
    "documents-generated-no-items-selected": "nejsou vybrány žádné položky",
    "documents-generated-no-items-selected-message": "prosím vyberte alespoň jedno generování k obnovení",
    "documents-generated-regeneration-successful": "obnovení úspěšné",
    "documents-generated-regeneration-successful-message": "%0 generování obnoveno",
    "documents-generated-regeneration-completed-with-errors": "obnovení dokončeno s chybami",
    "documents-generated-regeneration-completed-with-errors-message": "%0 úspěšných, %1 selhalo",
    "documents-generated-status-pending": "čeká",
    "documents-generated-status-processing": "zpracovává se",
    "documents-generated-status-completed": "dokončeno",
    "documents-generated-status-failed": "selhalo",
    "documents-generated-status-cancelled": "zrušeno",

    // document layouts list
    "document-layouts-table-col-name": "název",
    "document-layouts-table-col-type": "typ",
    "document-layouts-table-col-size": "velikost",
    "document-layouts-table-col-orientation": "orientace",
    "document-layouts-table-col-system": "systém",
    "document-layouts-table-col-created": "vytvořeno",
    "document-layouts-table-col-updated": "aktualizováno",
    "document-layouts-table-yes": "ano",
    "document-layouts-table-no": "ne",
    "document-layouts-table-type-voucher": "poukaz",
    "document-layouts-table-type-sticker": "samolepka",
    "document-layouts-table-type-invoice": "faktura",
    "document-layouts-table-type-shipping_label": "dopravní štítek",
    "document-layouts-table-type-packing_slip": "balicí list",
    "document-layouts-table-type-card": "karta",
    "document-layouts-table-size-A4": "A4",
    "document-layouts-table-size-A5": "A5",
    "document-layouts-table-size-credit_card": "kreditní karta",
    "document-layouts-table-size-custom": "vlastní",
    "document-layouts-table-orientation-portrait": "na výšku",
    "document-layouts-table-orientation-landscape": "na šířku",

    // document templates list
    "document-templates-table-col-name": "název",
    "document-templates-table-col-layout": "rozložení",
    "document-templates-table-col-supported-locales": "podporované jazyky",
    "document-templates-table-col-created": "vytvořeno",
    "document-templates-table-col-updated": "aktualizováno",

    // document template add form - preview banner and buttons
    "document-template-add-form-download-preview": "stáhnout náhled",
    "document-template-add-form-save": "uložit",
    "document-template-add-form-cancel": "zrušit",
    "document-template-add-form-preview-lang": "jazyk",
    "document-template-add-form-preview-output": "výstup",
    "document-template-add-form-preview-output-print": "tisk",
    "document-template-add-form-preview-output-digital": "digitální",
    "document-template-add-form-preview-highlight-final-size": "zvýraznit finální velikost",
    "document-template-add-form-preview-highlight-margin": "zvýraznit okraj",
    "document-template-add-form-preview-highlight-bleed-box": "zvýraznit spadávku",
    "document-template-add-form-preview-reset": "resetovat",
    "document-template-add-form-preview-rendering": "vykresluji PDF...",
    "document-template-add-form-no-objects-to-edit": "Žádné objekty k úpravě. Všechny objekty jsou automaticky generovány.",
    "document-template-add-form-placeholders": "Zástupné symboly: [VALID_TO], [VALID_FROM], [ORDER_ID], [ORDER_NUMBER], [PRODUCT_NAME], [FACE_VALUE]",
    "document-template-add-form-image-fit": "Přizpůsobení obrázku",
    "document-template-add-form-image-fit-fill": "Vyplnit (Krytí)",
    "document-template-add-form-image-fit-fit": "Přizpůsobit (Obsahovat)",
    "document-template-add-form-image-fit-stretch": "Roztáhnout (Zkreslit)",
    "document-template-add-form-image-position": "Pozice obrázku",
    "document-template-add-form-image-position-top-left": "Nahoře vlevo",
    "document-template-add-form-image-position-top-center": "Nahoře na středu",
    "document-template-add-form-image-position-top-right": "Nahoře vpravo",
    "document-template-add-form-image-position-middle-left": "Uprostřed vlevo",
    "document-template-add-form-image-position-middle-center": "Uprostřed na středu",
    "document-template-add-form-image-position-middle-right": "Uprostřed vpravo",
    "document-template-add-form-image-position-bottom-left": "Dole vlevo",
    "document-template-add-form-image-position-bottom-center": "Dole na středu",
    "document-template-add-form-image-position-bottom-right": "Dole vpravo",
    "document-template-add-form-image-position-center": "Na středu",
    "document-template-add-form-image-position-custom": "Vlastní",
    "document-template-add-form-image-position-x": "X (%)",
    "document-template-add-form-image-position-y": "Y (%)",
    "document-template-add-form-alert-select-layout": "Prosím vyberte rozložení a vyplňte hodnoty objektů",
    "document-template-add-form-alert-download-error": "Chyba při stahování náhledu:",

    // loyalty
    "loyalty": "věrnost",
    "view-title-loyalty": "věrnost",
    "view-title-loyalty-discounts": "slevy",
    "view-title-loyalty-discounts-add": "přidat slevu",
    "view-title-loyalty-discounts-edit": "upravit slevu",
    "view-title-loyalty-discounts-detail": "detail slevy",
    "view-title-loyalty-transactions": "transakce",
    "loyalty-discounts-table-col-name": "název",
    "loyalty-discounts-table-col-type": "typ",
    "loyalty-discounts-table-col-value": "hodnota",
    "loyalty-discounts-table-col-currency": "měna",
    "loyalty-discounts-table-col-enabled": "aktivní",
    "loyalty-transactions-table-col-person": "osoba",
    "loyalty-transactions-table-col-type": "typ",
    "loyalty-transactions-table-col-name": "název",
    "loyalty-transactions-table-col-bill": "účet",
    "loyalty-transactions-table-col-discount": "sleva",
    "loyalty-transactions-table-col-bill-before": "účet před",
    "loyalty-transactions-table-col-amount": "částka",
    "loyalty-transactions-table-col-bill-after": "účet po",
    "loyalty-transactions-table-col-created": "vytvořeno",
    "loyalty-transactions-table-col-status": "stav",
    "loyalty-transactions-type-discount": "sleva",
    "loyalty-transactions-type-cashback": "cashback",
    "loyalty-transactions-type-topup_bonus": "bonus za připisání",
    "loyalty-transactions-type-points": "body",
    "loyalty-transactions-type-stamp": "razítko",
    "loyalty-transactions-type-reward": "odměna",
    "loyalty-transactions-status-pending": "čekající",
    "loyalty-transactions-status-success": "úspěch",
    "loyalty-transactions-status-failed": "selhalo",
    "loyalty-transactions-status-canceled": "zrušeno",
    "loyalty-discounts-filter-placeholder": "hledat",
    "loyalty-discounts-add-button-label": "sleva",
    "loyalty-discount-form-field-name-label": "název",
    "loyalty-discount-form-field-name-caption": "název slevy",
    "loyalty-discount-form-field-slug-label": "slug",
    "loyalty-discount-form-field-slug-caption": "url slug",
    "loyalty-discount-form-field-description-label": "popis",
    "loyalty-discount-form-field-description-caption": "popis slevy",
    "loyalty-discount-form-field-name-on-loyalty-card-label": "název na kartě",
    "loyalty-discount-form-field-name-on-loyalty-card-caption": "název zobrazený na kartě věrnostního programu",
    "loyalty-discount-form-field-type-label": "typ",
    "loyalty-discount-form-field-type-caption": "typ slevy",
    "loyalty-discount-form-field-type-option-percentage": "procento",
    "loyalty-discount-form-field-type-option-fixed-amount": "pevná částka",
    "loyalty-discount-form-field-value-label": "hodnota",
    "loyalty-discount-form-field-value-caption": "hodnota slevy",
    "loyalty-discount-form-field-currency-label": "měna",
    "loyalty-discount-form-field-currency-caption": "měna",
    "loyalty-discount-form-field-scope-label": "scope",
    "loyalty-discount-form-field-scope-caption": "scope",
    "loyalty-discount-form-field-enabled-label": "aktivní",
    "loyalty-discount-form-action-save-label": "uložit",
    "loyalty-discount-form-action-cancel-label": "zrušit",
    "loyalty-stamp-card-form-field-enabled-label": "aktivní",
    "loyalty-stamp-card-form-section-tracks": "dráhy",
    "loyalty-stamp-card-form-action-add-track": "přidat dráhu",
    "loyalty-stamp-card-form-track-stamps-required-label": "počet razítek",
    "loyalty-stamp-card-form-track-stamps-required-caption": "Počet polí na kartě do odměny (např. 7 pro 6+1 zdarma).",
    "loyalty-stamp-card-form-track-signup-stamps-label": "razítka při registraci",
    "loyalty-stamp-card-form-track-signup-stamps-caption": "Počet razítek při přihlášení zákazníka k této dráze na join stránce.",
    "loyalty-stamp-card-form-track-image-set-key-label": "klíč sady obrázků",
    "loyalty-stamp-card-form-track-image-set-key-caption": "Klíč ve wallet pass config (stampImageSets). Výchozí je slug dráhy nebo \"default\".",
    "loyalty-stamp-card-form-track-product-ids-label": "ID produktů",
    "loyalty-stamp-card-form-track-product-ids-caption": "Storyous product ID, oddělená čárkou. Položka sedí, pokud je její product ID v seznamu.",
    "loyalty-stamp-card-form-track-category-ids-label": "ID kategorií",
    "loyalty-stamp-card-form-track-category-ids-caption": "Storyous category ID, oddělená čárkou. Položka sedí, pokud má kategorii ze seznamu.",
    "loyalty-stamp-card-form-track-name-label": "název dráhy",
    "loyalty-stamp-card-form-track-name-caption": "Název pro zákazníka (např. pečivo, káva).",
    "loyalty-stamp-card-form-track-slug-label": "slug dráhy",
    "loyalty-stamp-card-form-track-slug-caption": "Stabilní identifikátor pro wallet obrázky a stampImageSetKey.",
    "loyalty-stamp-card-list-col-name": "název",
    "loyalty-stamp-card-list-col-tracks": "dráhy",
    "loyalty-stamp-card-list-col-enabled": "aktivní",
    "loyalty-stamp-card-stats-active-instances": "aktivní karty",
    "loyalty-stamp-card-stats-enrollments": "registrace",
    "loyalty-stamp-card-detail-section-active-instances": "aktivní zákaznické karty",
    "loyalty-stamp-card-detail-section-activity": "nedávná aktivita",
    "loyalty-stamp-card-instances-col-person": "zákazník",
    "loyalty-stamp-card-instances-col-track": "dráha",
    "loyalty-stamp-card-instances-col-stamps": "razítka",
    "loyalty-stamp-card-instances-col-status": "stav",
    "loyalty-stamp-card-instances-col-created": "vytvořeno",
    "loyalty-stamp-card-activity-col-created": "vytvořeno",
    "loyalty-stamp-card-activity-col-person": "zákazník",
    "loyalty-stamp-card-activity-col-instance": "karta",
    "loyalty-stamp-card-activity-instance-n": "{n}. karta",
    "loyalty-stamp-card-activity-col-track": "dráha",
    "loyalty-stamp-card-activity-col-type": "typ",
    "loyalty-stamp-card-activity-col-delta": "razítka ±",
    "loyalty-stamp-card-activity-col-bill": "účet",
    "loyalty-stamp-card-activity-col-status": "stav",
    "loyalty-stamp-card-instance-label-person": "zákazník",
    "loyalty-stamp-card-instance-label-track": "dráha",
    "loyalty-stamp-card-instance-label-status": "stav",
    "loyalty-stamp-card-instance-label-stamps": "razítka",
    "loyalty-stamp-card-instance-label-created": "vytvořeno",
    "loyalty-stamp-card-instance-action-back": "zpět na razítkovou kartu",
    "loyalty-stamp-card-instance-not-found": "instance razítkové karty nenalezena",
    "view-title-loyalty-stamp-card-instance": "instance razítkové karty",
    "loyalty-stamp-card-track-action-view-activity": "zobrazit aktivitu",
    "loyalty-stamp-card-track-action-back": "zpět na konfiguraci",
    "loyalty-stamp-card-track-empty-instances": "Na této dráze nemáte žádné otevřené zákaznické karty.",
    "loyalty-stamp-card-track-empty-activity":
      "Zatím žádná aktivita z pokladny. Transakce razítek a odměn se zobrazí po připsání nebo uplatnění ve Storyous — razítka při registraci kartu jen nastaví.",
    "loyalty-stamp-card-track-not-found": "dráha nenalezena",
    "view-title-loyalty-stamp-card-track": "dráha razítkové karty",
    "loyalty-discount-detail-label-enabled": "aktivní",
    "loyalty-discount-detail-label-name": "název",
    "loyalty-discount-detail-label-slug": "slug",
    "loyalty-discount-detail-label-description": "popis",
    "loyalty-discount-detail-label-name-on-loyalty-card": "název na kartě",
    "loyalty-discount-detail-label-type": "typ",
    "loyalty-discount-detail-label-value": "hodnota",
    "loyalty-discount-detail-label-currency": "měna",
    "loyalty-discount-detail-action-enable": "povolit",
    "loyalty-discount-detail-action-disable": "zakázat",
    "loyalty-discount-detail-action-edit": "upravit",
    "loyalty-discount-detail-action-delete": "smazat",
    "view-title-loyalty-join-pages": "registrační stránky",
    "view-title-loyalty-join-pages-add": "přidat registrační stránku",
    "view-title-loyalty-join-pages-edit": "upravit registrační stránku",
    "view-title-loyalty-join-pages-detail": "detail registrační stránky",
    "loyalty-join-pages-table-col-name": "název",
    "loyalty-join-pages-table-col-slug": "slug",
    "loyalty-join-pages-table-col-discount": "sleva",
    "loyalty-join-pages-table-col-cashback": "cashback",
    "loyalty-join-pages-table-col-topup-bonus": "bonus za připisání",
    "loyalty-join-page-form-field-name-label": "název",
    "loyalty-join-page-form-field-name-caption": "interní, není viditelné zákazníkům",
    "loyalty-join-page-form-field-slug-label": "slug",
    "loyalty-join-page-form-field-slug-caption": "url stránky, např. yoursite.cz/loyalty/join/SLUG",
    "loyalty-join-page-form-field-title-label": "nadpis",
    "loyalty-join-page-form-field-description-label": "popis",
    "loyalty-join-page-form-field-discount-label": "sleva",
    "loyalty-join-page-detail-section-basic": "základní údaje",
    "loyalty-join-page-detail-label-name": "název",
    "loyalty-join-page-detail-label-slug": "slug",
    "loyalty-join-page-detail-label-title": "nadpis",
    "loyalty-join-page-detail-label-description": "popis",
    "loyalty-join-page-detail-label-discount": "sleva",
    "loyalty-join-page-detail-label-url": "url",
    "loyalty-join-page-detail-action-edit": "upravit",
    "loyalty-join-page-form-action-save-label": "uložit",
    "loyalty-join-page-form-action-cancel-label": "zrušit",
    "loyalty-join-page-form-field-name-placeholder": "zákazníci z ulice",
    "loyalty-join-page-form-field-slug-placeholder": "zakaznici-z-ulice",
    "loyalty-join-page-form-field-title-placeholder": "Připojte se k našemu věrnostnímu programu",
    "loyalty-join-page-form-field-description-placeholder": "Získáte slevu na každou objednávku. Čím více utratíte, tím více dostanete.",
    "loyalty-join-page-form-field-discount-caption": "přiřazená sleva po přihlášení",
    "loyalty-join-page-auto-activate-discount-label": "automaticky aktivovat slevu",
    "loyalty-join-page-assign-discount-label": "přiřadit slevu",
    "loyalty-join-page-create-balance-label": "vytvořit konto",
    "loyalty-discount-status-pending": "čekající",
    "loyalty-discount-status-active": "aktivní",
    "loyalty-discount-join-page-origin": "z registrační stránky",
    "loyalty-discount-activate-action": "aktivovat",
    "loyalty-discount-deactivate-action": "deaktivovat",

    // loyalty cashback
    "view-title-loyalty-cashbacks": "cashbacky",
    "view-title-loyalty-stamp-cards": "razítkové karty",
    "loyalty-cashbacks-table-col-name": "název",
    "loyalty-cashbacks-table-col-type": "typ",
    "loyalty-cashbacks-table-col-value": "hodnota",
    "loyalty-cashbacks-table-col-expiration": "platnost",
    "loyalty-cashbacks-table-col-enabled": "aktivní",
    "loyalty-cashback-form-field-name-label": "název",
    "loyalty-cashback-form-field-slug-label": "slug",
    "loyalty-cashback-form-field-description-label": "popis",
    "loyalty-cashback-form-field-transaction-description-label": "popis transakce",
    "loyalty-cashback-form-field-name-on-loyalty-card-label": "název na kartě",
    "loyalty-cashback-form-field-type-label": "typ",
    "loyalty-cashback-form-field-type-option-percentage": "procento",
    "loyalty-cashback-form-field-type-option-fixed-amount": "fixní částka",
    "loyalty-cashback-form-field-value-label": "hodnota",
    "loyalty-cashback-form-field-value-calc-base-label": "základ výpočtu",
    "loyalty-cashback-form-field-value-calc-base-caption": "z čeho a jak se počítá základ pro procento",
    "loyalty-cashback-form-field-calculation-rules-label": "pravidla výpočtu",
    "loyalty-cashback-form-field-calculation-rules-caption": "volitelně zuž výpočet (platební metody, max. cashback)",
    "loyalty-cashback-form-field-calculation-rules-payment-methods-hint": "počítat hodnotu z vybraných platebních metod (např. jen hotovost, jen karta)",
    "loyalty-cashback-form-field-base-filters-items-note": "platí jen při výpočtu z položek",
    "loyalty-cashback-form-field-base-filters-bill-note": "platí jen při výpočtu z útraty",
    "loyalty-cashback-form-field-base-filters-irrelevant-note": "tento filtr platí jen při výpočtu z položek – změň základ nebo smaž",
    "loyalty-cashback-form-field-value-calc-caption": "volitelně přidej kategorie, min/max cenu, cap",
    "loyalty-cashback-form-field-value-calc-rule-label": "pravidlo",
    "loyalty-cashback-form-field-value-calc-kind-label": "typ",
    "loyalty-cashback-form-field-value-calc-categories-label": "zahrnout kategorie",
    "loyalty-cashback-form-field-value-calc-categories-hint": "které položky zahrnout do výpočtu",
    "loyalty-cashback-form-field-value-calc-categories-placeholder": "načti kategorie z POS integrace",
    "loyalty-cashback-form-field-value-calc-categories-ids-placeholder": "ID kategorií (oddělená čárkou)",
    "loyalty-cashback-form-field-value-calc-from-label": "počítat z",
    "loyalty-cashback-form-field-value-calc-from-bill-total": "celková útrata",
    "loyalty-cashback-form-field-value-calc-from-items": "položky",
    "loyalty-cashback-form-field-value-calc-taxes-label": "DPH",
    "loyalty-cashback-form-field-value-calc-taxes-included": "včetně",
    "loyalty-cashback-form-field-value-calc-taxes-excluded": "bez",
    "loyalty-cashback-form-field-value-calc-discounts-label": "slevy",
    "loyalty-cashback-form-field-value-calc-discounts-before": "před",
    "loyalty-cashback-form-field-value-calc-discounts-after": "po",
    "loyalty-cashback-form-field-value-calc-tips-label": "spropitné",
    "loyalty-cashback-form-field-value-calc-tips-included": "včetně",
    "loyalty-cashback-form-field-value-calc-tips-excluded": "bez",
    "loyalty-cashback-form-field-value-calc-min-bill-total-label": "min. útrata (vč. DPH)",
    "loyalty-cashback-form-field-value-calc-max-bill-total-label": "max. útrata (vč. DPH)",
    "loyalty-cashback-form-field-value-calc-payment-methods-label": "platební metody",
    "loyalty-cashback-form-field-payment-method-cash": "hotovost",
    "loyalty-cashback-form-field-payment-method-card": "karta",
    "loyalty-cashback-form-field-payment-method-balance": "balance",
    "loyalty-cashback-form-field-payment-method-filter-label": "platební metody",
    "loyalty-cashback-form-field-payment-method-filter-caption": "část účtu pro výpočet",
    "loyalty-cashback-form-field-payment-method-filter-all": "celý účet",
    "loyalty-cashback-form-field-payment-method-filter-include-only": "pouze vybrané",
    "loyalty-cashback-form-field-payment-method-filter-exclude": "vybrané vyloučit",
    "loyalty-cashback-form-field-payment-methods-include-hint": "např. hotovost, karta",
    "loyalty-cashback-form-field-payment-methods-exclude-hint": "např. balance",
    "loyalty-cashback-form-field-value-calc-min-price-pc-label": "min. cena / ks (vč. DPH)",
    "loyalty-cashback-form-field-value-calc-max-price-pc-label": "max. cena / ks (vč. DPH)",
    "loyalty-cashback-form-field-value-calc-excluded-items-label": "vyloučené položky",
    "loyalty-cashback-form-field-value-calc-excluded-items-placeholder": "ID produktů/kategorií z POS (oddělená čárkou)",
    "loyalty-cashback-form-field-value-calc-min-quantity-label": "min. množství",
    "loyalty-cashback-form-field-value-calc-min-quantity-scope-label": "rozsah",
    "loyalty-cashback-form-field-value-calc-min-quantity-per-product": "na produkt",
    "loyalty-cashback-form-field-value-calc-min-quantity-all-products": "celkem",
    "loyalty-cashback-form-field-value-calc-cap-label": "max. cashback / účet",
    "loyalty-cashback-form-field-cap-enabled-label": "omezit max. cashback na účet",
    "loyalty-cashback-form-field-expiration-label": "platnost",
    "loyalty-cashback-form-field-expiration-option-p7d": "7 dní",
    "loyalty-cashback-form-field-expiration-option-p14d": "14 dní",
    "loyalty-cashback-form-field-expiration-option-p1m": "1 měsíc",
    "loyalty-cashback-form-field-expiration-option-p3m": "3 měsíce",
    "loyalty-cashback-form-field-expiration-option-p6m": "6 měsíců",
    "loyalty-cashback-form-field-expiration-option-p1y": "1 rok",
    "loyalty-cashback-form-field-expiration-option-p2y": "2 roky",
    "loyalty-cashback-form-field-expiration-option-p3y": "3 roky",
    "loyalty-cashback-form-field-expiration-option-p5y": "5 let",
    "loyalty-cashback-form-field-expiration-option-2099": "2099",
    "loyalty-cashback-form-field-apply-delay-label": "zpoždění aplikace",
    "loyalty-cashback-form-field-apply-delay-caption": "kdy se cashback přičte na účet",
    "loyalty-cashback-form-field-apply-delay-enabled-label": "aplikovat zpoždění",
    "loyalty-cashback-form-field-apply-delay-in-duration": "za",
    "loyalty-cashback-form-field-apply-delay-days": "dní",
    "loyalty-cashback-form-field-apply-delay-hours": "hodin",
    "loyalty-cashback-form-field-apply-delay-minutes": "minut",
    "loyalty-cashback-form-field-apply-delay-offset-days-label": "dní (0 = dnes, 1 = zítra)",
    "loyalty-cashback-form-field-apply-delay-offset-weeks-label": "týdnů (0 = tento týden, 1 = příští)",
    "loyalty-cashback-form-field-apply-delay-offset-months-label": "měsíců (0 = tento měsíc, 1 = příští)",
    "loyalty-cashback-form-field-apply-delay-type-next-day": "o půlnoci (den)",
    "loyalty-cashback-form-field-apply-delay-type-next-week": "konec týdne",
    "loyalty-cashback-form-field-apply-delay-type-next-month": "konec měsíce",
    "loyalty-cashback-form-field-timezone-display-label": "časová zóna",
    "loyalty-cashback-form-field-enabled-label": "aktivní",
    "loyalty-cashback-form-field-applied-when-label": "platí když",
    "loyalty-cashback-form-field-applied-when-caption": "cashback se uplatní, pokud jsou splněna všechna následující pravidla",
    "loyalty-cashback-form-field-rules-label": "pravidla",
    "loyalty-cashback-form-field-rules-caption": "cashback platí, pokud jsou splněna všechna následující pravidla",
    "loyalty-cashback-form-field-rule-label": "pravidlo",
    "loyalty-cashback-form-field-rule-kind-label": "typ pravidla",
    "loyalty-cashback-form-field-trigger-bill-opened": "účet otevřen",
    "loyalty-cashback-form-field-trigger-bill-paid": "účet zaplacen",
    "loyalty-cashback-form-field-rule-min-bill-total": "min. útrata",
    "loyalty-cashback-form-field-rule-max-bill-total": "max. útrata",
    "loyalty-cashback-form-field-rule-payment-methods": "platební metody",
    "loyalty-cashback-form-field-rule-min-quantity": "min. množství",
    "loyalty-cashback-form-field-rule-excluded-items": "vyloučené položky",
    "loyalty-cashback-form-field-rule-category-filter": "účet musí obsahovat kategorie",
    "loyalty-cashback-form-field-rule-category-filter-hint": "účet musí mít alespoň jednu položku z těchto kategorií",
    "loyalty-cashback-form-field-day-of-week-label": "den v týdnu",
    "loyalty-cashback-form-field-day-mo": "po",
    "loyalty-cashback-form-field-day-tu": "út",
    "loyalty-cashback-form-field-day-we": "st",
    "loyalty-cashback-form-field-day-th": "čt",
    "loyalty-cashback-form-field-day-fr": "pá",
    "loyalty-cashback-form-field-day-sa": "so",
    "loyalty-cashback-form-field-day-su": "ne",
    "loyalty-cashback-form-field-time-from-label": "čas od",
    "loyalty-cashback-form-field-time-to-label": "čas do",
    "loyalty-cashback-form-field-timezone-label": "časová zóna",
    "loyalty-cashback-form-action-save-label": "uložit",
    "loyalty-cashback-form-action-cancel-label": "zrušit",
    "loyalty-cashback-detail-label-enabled": "aktivní",
    "loyalty-cashback-detail-label-name": "název",
    "loyalty-cashback-detail-label-slug": "slug",
    "loyalty-cashback-detail-label-description": "popis",
    "loyalty-cashback-detail-label-name-on-loyalty-card": "název na kartě",
    "loyalty-cashback-detail-label-type": "typ",
    "loyalty-cashback-detail-label-value": "hodnota",
    "loyalty-cashback-detail-label-expiration": "platnost",
    "loyalty-cashback-detail-action-enable": "povolit",
    "loyalty-cashback-detail-action-disable": "zakázat",
    "loyalty-cashback-detail-action-edit": "upravit",
    "loyalty-join-page-assign-cashback-label": "přiřadit cashback",
    "loyalty-join-page-assign-cashback-requires-balance-caption": "vyžaduje vytvoření konta",
    "loyalty-join-page-form-field-cashback-label": "cashback",
    "loyalty-join-page-form-field-cashback-caption": "přiřazený cashback po přihlášení",
    "loyalty-join-page-auto-activate-cashback-label": "automaticky aktivovat cashback",
    "loyalty-join-page-detail-label-cashback": "cashback",
    "loyalty-join-page-assign-topup-bonus-label": "přiřadit bonus za připisání",
    "loyalty-join-page-assign-topup-bonus-requires-balance-caption": "vyžaduje vytvoření konta",
    "loyalty-join-page-assign-topup-bonus-requires-allowCredit-caption": "vyžaduje povolené připisování na konto",
    "loyalty-join-page-form-field-topup-bonus-label": "bonus za připisání",
    "loyalty-join-page-form-field-topup-bonus-caption": "přiřazený bonus za připisání po přihlášení",
    "loyalty-join-page-auto-activate-topup-bonus-label": "automaticky aktivovat bonus za připisání",
    "loyalty-join-page-detail-label-topup-bonus": "bonus za připisání",
    "loyalty-topup-bonus-status-active": "aktivní",
    "loyalty-topup-bonus-status-pending": "čekající",
    "loyalty-topup-bonus-activate-action": "aktivovat",
    "loyalty-topup-bonus-join-page-origin": "z registrační stránky",
    "loyalty-cashback-status-pending": "čekající",
    "loyalty-cashback-status-active": "aktivní",
    "loyalty-cashback-join-page-origin": "z registrační stránky",
    "loyalty-cashback-activate-action": "aktivovat",

    "view-title-loyalty-topup-bonuses": "bonusy za připisání",
    "view-title-loyalty-topup-bonuses-add": "přidat bonus za připisání",
    "view-title-loyalty-topup-bonuses-detail": "bonus za připisání",
    "view-title-loyalty-topup-bonuses-edit": "upravit bonus za připisání",
    "loyalty-topup-bonuses-table-col-name": "název",
    "loyalty-topup-bonuses-table-col-type": "typ",
    "loyalty-topup-bonuses-table-col-value": "hodnota",
    "loyalty-topup-bonuses-table-col-channels": "kanály",
    "loyalty-topup-bonuses-table-col-enabled": "aktivní",
    "loyalty-topup-bonus-form-field-enabled-label": "aktivní",
    "loyalty-topup-bonus-form-field-name-label": "název",
    "loyalty-topup-bonus-form-field-description-label": "popis",
    "loyalty-topup-bonus-form-field-transaction-description-label": "popis transakce",
    "loyalty-topup-bonus-form-field-type-label": "typ",
    "loyalty-topup-bonus-form-field-type-option-percentage": "procento",
    "loyalty-topup-bonus-form-field-type-option-fixed-amount": "pevná částka",
    "loyalty-topup-bonus-form-field-value-label": "hodnota",
    "loyalty-topup-bonus-form-field-cap-label": "strop (max. bonus na doplnění)",
    "loyalty-topup-bonus-form-field-channels-label": "kanály",
    "loyalty-topup-bonus-form-field-channels-caption": "allow list: platí jen pro vybrané kanály (prázdné = všechny)",
    "loyalty-topup-bonus-form-field-channel-pos": "POS",
    "loyalty-topup-bonus-form-field-channel-storefront": "obchod",
    "loyalty-topup-bonus-form-field-balance-group-label": "skupina balance (volitelné)",
    "loyalty-topup-bonus-form-field-rules-label": "pravidla",
    "loyalty-topup-bonus-form-field-rules-caption": "bonus platí, pokud jsou splněna všechna pravidla",
    "loyalty-topup-bonus-form-field-rule-label": "pravidlo",
    "loyalty-topup-bonus-form-field-rule-kind-label": "typ pravidla",
    "loyalty-topup-bonus-form-field-rule-valid-from": "platné od",
    "loyalty-topup-bonus-form-field-rule-valid-to": "platné do",
    "loyalty-topup-bonus-form-field-rule-min-topup-amount": "min. částka doplnění",
    "loyalty-topup-bonus-form-field-rule-max-topup-amount": "max. částka doplnění",
    "loyalty-topup-bonus-form-field-rule-day-of-week": "den v týdnu + čas",
    "loyalty-topup-bonus-form-field-rule-value-label": "hodnota",
    "loyalty-topup-bonus-form-action-save-label": "uložit",
    "loyalty-topup-bonus-form-action-cancel-label": "zrušit",
    "loyalty-topup-bonus-detail-label-enabled": "aktivní",
    "loyalty-topup-bonus-detail-label-name": "název",
    "loyalty-topup-bonus-detail-label-type": "typ",
    "loyalty-topup-bonus-detail-label-value": "hodnota",
    "loyalty-topup-bonus-detail-label-cap": "strop",
    "loyalty-topup-bonus-detail-label-channels": "kanály",
    "loyalty-topup-bonus-detail-label-balance-group": "skupina balance",
    "loyalty-topup-bonus-detail-action-enable": "aktivovat",
    "loyalty-topup-bonus-detail-action-disable": "deaktivovat",
    "loyalty-topup-bonus-detail-action-edit": "upravit",
    "loyalty-topup-bonus-detail-action-delete": "smazat",
  },
}
